<template>
  <div class="dashboard-container">
    <!-- Cabeçalho -->
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <div class="d-flex align-center justify-space-between mb-4">
            <div>
              <h1 class="text-h4 font-weight-bold">Dashboard de Atualizações</h1>
              <p class="text-subtitle-1 text--secondary">
                Visualize e monitore as atualizações dos sistemas
              </p>
            </div>
            <div class="d-flex align-center">
              <v-chip
                :color="filtrosAplicados ? 'primary' : 'default'"
                small
                class="mr-2"
              >
                {{ filtrosAplicados ? 'Filtros aplicados' : 'Todos os dados' }}
              </v-chip>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="success"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    :loading="exportando"
                    :disabled="exportando || loading"
                  >
                    <v-icon left>mdi-file-export</v-icon>
                    Exportar
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="exportarDados('xlsx')">
                    <v-list-item-icon>
                      <v-icon>mdi-file-excel</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Exportar para Excel (XLSX)</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="exportarDados('csv')">
                    <v-list-item-icon>
                      <v-icon>mdi-file-delimited</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Exportar para CSV</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn
                icon
                @click="atualizarDados"
                :loading="loading"
                :disabled="loading"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Filtros -->
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              <v-icon class="mr-2">mdi-filter</v-icon>
              Filtros
              <v-spacer></v-spacer>
              <v-btn
                text
                small
                @click="mostrarFiltros = !mostrarFiltros"
              >
                {{ mostrarFiltros ? 'Ocultar' : 'Mostrar' }}
                <v-icon>{{ mostrarFiltros ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </v-card-title>
            
            <v-expand-transition>
              <div v-show="mostrarFiltros">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-menu
                        v-model="menuDataInicio"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="filtros.dataInicio"
                            label="Data de início"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="filtros.dataInicio"
                          :picker-date.sync="pickerMonthInicio"
                          :events="isUpdateDay"
                          :event-color="eventColor"
                          :first-day-of-week="0"
                          @input="menuDataInicio = false"
                          locale="pt-BR"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="filtros.horaInicio"
                        label="Hora início"
                        type="time"
                        prepend-icon="mdi-clock"
                        clearable
                        dense
                        hint="Se não especificado, usa 00:00"
                        mask="##:##"
                        placeholder="HH:MM"
                      ></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" md="3">
                      <v-menu
                        v-model="menuDataFim"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="filtros.dataFim"
                            label="Data de fim"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="filtros.dataFim"
                          :picker-date.sync="pickerMonthFim"
                          :events="isUpdateDay"
                          :event-color="eventColor"
                          :first-day-of-week="0"
                          @input="menuDataFim = false"
                          locale="pt-BR"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="filtros.horaFim"
                        label="Hora fim"
                        type="time"
                        prepend-icon="mdi-clock"
                        clearable
                        dense
                        hint="Se não especificado, usa 23:59"
                        mask="##:##"
                        placeholder="HH:MM"
                      ></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" md="2">
                      <v-btn
                        color="primary"
                        @click="aplicarFiltros"
                        :loading="loading"
                        block
                      >
                        <v-icon left>mdi-filter</v-icon>
                        Aplicar
                      </v-btn>
                    </v-col>
                  </v-row>
                  
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="filtros.sistemas"
                        :items="opcoesFilters.sistemas"
                        label="Sistema"
                        multiple
                        chips
                        clearable
                        prepend-icon="mdi-application"
                        small-chips
                      >
                        <template v-slot:selection="{ item, index }">
                          <v-chip
                            v-if="index < 2"
                            small
                            :color="getCorSistema(item)"
                            outlined
                            class="mr-1"
                          >
                            {{ item }}
                          </v-chip>
                          <span v-if="index === 2" class="grey--text text-caption">
                            (+{{ filtros.sistemas.length - 2 }})
                          </span>
                        </template>
                      </v-select>
                    </v-col>
                    
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="filtros.metodos"
                        :items="opcoesFilters.metodos"
                        label="Métodos"
                        multiple
                        chips
                        clearable
                        prepend-icon="mdi-cog"
                        small-chips
                      >
                        <template v-slot:selection="{ item, index }">
                          <v-chip
                            v-if="index < 2"
                            small
                            :color="item === 'CRONOGRAMA_RETRY' ? undefined : getCorMetodo(item)"
                            :style="getChipStyle(item)"
                            outlined
                            class="mr-1"
                          >
                            {{ item }}
                          </v-chip>
                          <span v-if="index === 2" class="grey--text text-caption">
                            (+{{ filtros.metodos.length - 2 }})
                          </span>
                        </template>
                      </v-select>
                    </v-col>
                    
                    <v-col cols="12" md="2">
                      <v-autocomplete
                        v-model="filtros.hostids"
                        :items="opcoesFilters.hosts"
                        item-text="name"
                        item-value="hostId"
                        label="Host"
                        multiple
                        chips
                        clearable
                        prepend-icon="mdi-server"
                        auto-select-first
                        hide-no-data
                        hide-selected
                        return-object
                        :filter="filtrarHosts"
                        @change="selecionarHosts"
                        small-chips
                      >
                        <template v-slot:selection="{ item, index }">
                          <v-chip
                            v-if="index < 2"
                            small
                            outlined
                            color="primary"
                            class="mr-1"
                          >
                            {{ item.name }}
                          </v-chip>
                          <span v-if="index === 2" class="grey--text text-caption">
                            (+{{ filtros.hostids.length - 2 }})
                          </span>
                        </template>
                        <template v-slot:item="{ item }">
                          <v-list-item-avatar>
                            <v-icon>mdi-server</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>{{ item.name }}</v-list-item-title>
                            <v-list-item-subtitle class="text--secondary">ID: {{ item.hostId }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="filtros.atualizado"
                        :items="[
                          { text: 'Todos', value: null },
                          { text: 'Sucessos', value: true },
                          { text: 'Falhas', value: false }
                        ]"
                        label="Status"
                        clearable
                        prepend-icon="mdi-check-circle"
                      ></v-select>
                    </v-col>
                    
                    <v-col cols="12" md="3">
                      <div class="base-size-filter">
                        <v-range-slider
                          v-model="baseSizeSliderValue"
                          :min="baseSizeRange.min"
                          :max="baseSizeRange.max"
                          :step="0.1"
                          color="primary"
                          track-color="grey lighten-2"
                          thumb-color="primary"
                          thumb-size="20"
                          hide-details
                          @input="updateBaseSizeFiltersRealTime"
                          @change="updateBaseSizeFilters"
                          @start="isSliderActive = true"
                          @end="isSliderActive = false"
                        >
                          <template v-slot:prepend>
                            <div class="text-center slider-value-display">
                              <v-text-field
                                v-model="filtros.baseSizeMin"
                                type="number"
                                :min="baseSizeRange.min"
                                :max="baseSizeRange.max"
                                :step="0.1"
                                dense
                                outlined
                                hide-details
                                style="width: 90px;"
                                @input="updateSliderFromInput"
                                class="slider-input"
                                :placeholder="baseSizeRange.min.toString()"
                              >
                                <template v-slot:append>
                                  <span class="text-caption text--secondary">GB</span>
                                </template>
                              </v-text-field>
                            </div>
                          </template>
                          
                          <template v-slot:append>
                            <div class="text-center slider-value-display">
                              <v-text-field
                                v-model="filtros.baseSizeMax"
                                type="number"
                                :min="baseSizeRange.min"
                                :max="baseSizeRange.max"
                                :step="0.1"
                                dense
                                outlined
                                hide-details
                                style="width: 90px;"
                                @input="updateSliderFromInput"
                                class="slider-input"
                                :placeholder="baseSizeRange.max.toString()"
                              >
                                <template v-slot:append>
                                  <span class="text-caption text--secondary">GB</span>
                                </template>
                              </v-text-field>
                            </div>
                          </template>
                        </v-range-slider>
                      </div>
                    </v-col>
                    
                    <v-col cols="12" md="1" class="d-flex align-center">
                      <v-btn
                        outlined
                        @click="limparFiltros"
                        :disabled="loading"
                        class="mr-2"
                      >
                        <v-icon left>mdi-filter-remove</v-icon>
                        Limpar
                      </v-btn>
                    </v-col>
                  </v-row>

                  <!-- Nova linha para opção de ignorar falhas com retry bem-sucedido -->
                  <v-row>
                    <v-col cols="12" class="mt-2">
                      <v-divider></v-divider>
                      <div class="d-flex align-center justify-space-between mt-2">
                        <div class="text-body-2 text--secondary">
                          <v-icon small color="info" class="mr-1">mdi-information</v-icon>
                          Opções avançadas de exibição
                        </div>
                      </div>
                      <v-switch
                        v-model="ignorarFalhasComRetry"
                        label="Ignorar falhas quando RETRY = atualizado"
                        color="success"
                        hint="Oculta falhas de CRONOGRAMA quando o respectivo RETRY foi bem-sucedido"
                        persistent-hint
                        dense
                        class="mt-2"
                        @change="alternarIgnorarFalhas"
                      >
                        <template v-slot:append>
                          <v-tooltip bottom max-width="300">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                small
                                color="info"
                                v-bind="attrs"
                                v-on="on"
                              >mdi-help-circle</v-icon>
                            </template>
                            <span>
                              Quando ativado, falhas de CRONOGRAMA serão ocultadas caso exista um CRONOGRAMA_RETRY bem-sucedido
                              no mesmo dia, para o mesmo host e sistema
                            </span>
                          </v-tooltip>
                        </template>
                      </v-switch>
                    </v-col>
                  </v-row>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>

      <!-- Métricas principais -->
      <v-row class="mt-4">
        <v-col cols="12" class="mb-2">
          <div v-if="ignorarFalhasComRetry && falhasOcultasPorRetry > 0" class="d-flex align-center">
            <v-chip
              x-small
              color="success"
              outlined
              class="mr-2"
            >
              <v-icon x-small left>mdi-filter-check</v-icon>
              {{ falhasOcultasPorRetry }} falhas ocultadas por RETRY bem-sucedido
            </v-chip>
            <span class="text-caption text--secondary">
              As métricas abaixo consideram apenas falhas sem RETRY bem-sucedido
            </span>
          </div>
        </v-col>
      </v-row>
      
      <v-row class="metrics-row">  
        <v-col cols="12" sm="6" md="2.4" class="metric-col">
          <v-card class="text-center modern-metric-card" elevation="4">
            <v-card-text class="py-3">
              <v-icon size="32" color="primary" class="mb-1">mdi-chart-line</v-icon>
              <div class="text-h4 font-weight-bold">{{ estatisticasAjustadas.totalAtualizacoes || 0 }}</div>
              <div class="text-body-2 text--secondary">Total de Atualizações</div>
            </v-card-text>
          </v-card>
        </v-col>
        
        <v-col cols="12" sm="6" md="2.4" class="metric-col">
          <v-card class="text-center modern-metric-card" elevation="4">
            <v-card-text class="py-3">
              <v-icon size="32" color="success" class="mb-1">mdi-check-circle</v-icon>
              <div class="text-h4 font-weight-bold text-success">{{ estatisticasAjustadas.totalSucessos || 0 }}</div>
              <div class="text-body-2 text--secondary">Atualizações com Sucesso</div>
            </v-card-text>
          </v-card>
        </v-col>
        
        <v-col cols="12" sm="6" md="2.4" class="metric-col">
          <v-card class="text-center modern-metric-card" elevation="4">
            <v-card-text class="py-3">
              <div class="text-body-2 text--secondary mb-1">Atualizações %</div>
              <div class="chart-container">
                <canvas id="chartAtualizacoesPorcentagem" height="80"></canvas>
              </div>
              <div class="porcentagem-info mt-1">
                <div class="d-flex justify-space-between align-center">
                  <div class="d-flex align-center">
                    <div class="color-indicator success-color mr-1"></div>
                    <span class="text-body-2">{{ porcentagemSucessoAjustada }}%</span>
                  </div>
                  <div class="d-flex align-center">
                    <div class="color-indicator error-color mr-1"></div>
                    <span class="text-body-2">{{ porcentagemFalhaAjustada }}%</span>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        
        <v-col cols="12" sm="6" md="2.4" class="metric-col">
          <v-card class="text-center modern-metric-card" elevation="4">
            <v-card-text class="py-3">
              <v-icon size="32" color="error" class="mb-1">mdi-alert-circle</v-icon>
              <div class="text-h4 font-weight-bold text-error">{{ estatisticasAjustadas.totalFalhas || 0 }}</div>
              <div class="text-body-2 text--secondary">Atualizações com Falha</div>
            </v-card-text>
          </v-card>
        </v-col>
        
        <v-col cols="12" sm="6" md="2.4" class="metric-col">
          <v-card class="text-center modern-metric-card" elevation="4">
            <v-card-text class="py-3">
              <v-icon size="32" color="info" class="mb-1">mdi-clock</v-icon>
              <div class="text-h4 font-weight-bold text-info">{{ formatarDuracao(estatisticas.tempoMedioExecucao) }}</div>
              <div class="text-body-2 text--secondary">Tempo Médio (Sucessos)</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="metrics-row mt-2">
        <v-col cols="12" sm="6" md="2.4" class="metric-col">
          <v-card class="text-center modern-metric-card-alt" elevation="4">
            <v-card-text class="py-3">
              <v-icon size="32" color="primary" class="mb-1">mdi-server</v-icon>
              <div class="text-h4 font-weight-bold">{{ estatisticas.totalHostsUnicos || 0 }}</div>
              <div class="text-body-2 text--secondary">Total de Clientes</div>
            </v-card-text>
          </v-card>
        </v-col>
        
        <v-col cols="12" sm="6" md="2.4" class="metric-col">
          <v-card class="text-center modern-metric-card-alt" elevation="4">
            <v-card-text class="py-3">
              <v-icon 
                size="32" 
                color="success" 
                class="mb-1"
                title="Perante as informações filtradas, contabiliza o total de clientes que tiveram todos os seus sistemas atualizados com sucesso"
              >mdi-check-circle</v-icon>
              <div class="text-h4 font-weight-bold text-success">{{ dadosPorClienteAjustados.hostsComSucesso || 0 }}</div>
              <div class="text-body-2 text--secondary">Clientes com Sucesso</div>
            </v-card-text>
          </v-card>
        </v-col>
        
        <v-col cols="12" sm="6" md="2.4" class="metric-col">
          <v-card class="text-center modern-metric-card-alt" elevation="4">
            <v-card-text class="py-3">
              <div class="text-body-2 text--secondary mb-1">Clientes %</div>
              <div class="chart-container">
                <canvas id="chartClientesPorcentagem" height="80"></canvas>
              </div>
              <div class="porcentagem-info mt-1">
                <div class="d-flex justify-space-between align-center">
                  <div class="d-flex align-center">
                    <div class="color-indicator success-color mr-1"></div>
                    <span class="text-body-2">{{ estatisticas.taxaSucessoPorHost || 0 }}%</span>
                  </div>
                  <div class="d-flex align-center">
                    <div class="color-indicator error-color mr-1"></div>
                    <span class="text-body-2">{{ (100 - (estatisticas.taxaSucessoPorHost || 0)).toFixed(1) }}%</span>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        
        <v-col cols="12" sm="6" md="2.4" class="metric-col">
          <v-card class="text-center modern-metric-card-alt" elevation="4">
            <v-card-text class="py-3">
              <v-icon 
                size="32" 
                color="error" 
                class="mb-1"
                title="Perante as informações filtradas, contabiliza o total de clientes que tiveram algum sistema atualizado com falha"
              >mdi-alert-circle</v-icon>
              <div class="text-h4 font-weight-bold text-error">{{ dadosPorClienteAjustados.hostsComFalha || 0 }}</div>
              <div class="text-body-2 text--secondary">Clientes com Falha</div>
            </v-card-text>
          </v-card>
        </v-col>
        
        <v-col cols="12" sm="6" md="2.4" class="metric-col">
          <v-card class="text-center modern-metric-card-alt" elevation="4">
            <v-card-text class="py-3">
              <v-icon size="32" color="info" class="mb-1">mdi-chart-areaspline</v-icon>
              <div class="text-h4 font-weight-bold text-info">{{ dadosPorClienteAjustados.totalHostsUnicos || 0 }}</div>
              <div class="text-body-2 text--secondary">Clientes Únicos</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col cols="12" md="3">
          <v-card class="modern-chart-card" elevation="6">
            <v-card-title class="text-center modern-chart-title">
              <v-icon class="mr-2">mdi-chart-bar</v-icon>
              Por Atualização
            </v-card-title>
            <v-card-text>
              <canvas id="chartSistemas" height="300"></canvas>
            </v-card-text>
          </v-card>
        </v-col>
        
        <!-- Gráfico: Atualizações por Sistema (Por Host/Hostid) -->
        <v-col cols="12" md="3">
          <v-card class="modern-chart-card-alt" elevation="6">
            <v-card-title class="text-center modern-chart-title-alt">
              <v-icon class="mr-2">mdi-chart-bar</v-icon>
              Por Cliente
            </v-card-title>
            <v-card-text>
              <canvas id="chartSistemasPorHost" height="300"></canvas>
            </v-card-text>
          </v-card>
        </v-col>
        
        <!-- Gráfico: Proporção por Método (Por Registro) -->
        <v-col cols="12" md="3">
          <v-card class="modern-chart-card" elevation="6">
            <v-card-title class="text-center modern-chart-title">
              <v-icon class="mr-2">mdi-chart-pie</v-icon>
              Por Atualização
            </v-card-title>
            <v-card-text>
              <canvas id="chartMetodos" height="300"></canvas>
            </v-card-text>
          </v-card>
        </v-col>
        
        <!-- Gráfico: Proporção por Método (Por Host/Hostid) -->
        <v-col cols="12" md="3">
          <v-card class="modern-chart-card-alt" elevation="6">
            <v-card-title class="text-center modern-chart-title-alt">
              <v-icon class="mr-2">mdi-chart-pie</v-icon>
              Por Cliente
            </v-card-title>
            <v-card-text>
              <canvas id="chartMetodosPorHost" height="300"></canvas>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Tabela de atualizações -->
      <v-row class="mt-4">
        <v-col cols="12">
          <v-card>
            <v-card-title>
              <v-icon class="mr-2">mdi-table</v-icon>
              Histórico de Atualizações
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchHistorico"
                append-icon="mdi-magnify"
                label="Pesquisar por nome do host"
                single-line
                hide-details
                clearable
                dense
                class="mt-0 pt-0"
                style="max-width: 300px;"
                @input="pesquisarHistorico"
              ></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headersAtualizacoes"
                :items="atualizacoes || []"
                :loading="loadingTabela"
                :options.sync="optionsTabela"
                :server-items-length="totalItens"
                :footer-props="{
                  'items-per-page-options': [5, 10, 20, 50, 100],
                  'items-per-page-text': 'Linhas por página:',
                  'page-text': '{0}-{1} de {2}'
                }"
                class="elevation-1"
              >
                <template v-slot:item.hostName="{ item }">
                  <v-chip small>{{ item.hostName }}</v-chip>
                </template>
                
                <template v-slot:item.hostid="{ item }">
                  <v-chip x-small outlined :color="$vuetify.theme.dark ? 'light-blue' : 'primary'" class="font-weight-medium chip-hostid">
                    {{ item.hostid }}
                  </v-chip>
                </template>
                
                <template v-slot:item.id="{ item }">
                  <v-chip x-small outlined :color="$vuetify.theme.dark ? 'teal' : 'secondary'" class="font-weight-medium chip-id">
                    {{ item.id }}
                  </v-chip>
                </template>
                
                <template v-slot:item.sistema="{ item }">
                  <div class="d-flex align-center">
                    <img 
                      :src="getIconeSistema(item.sistema)" 
                      :alt="item.sistema"
                      class="sistema-icon"
                      :title="item.sistema"
                    />
                    <span class="ml-2">{{ item.sistema }}</span>
                  </div>
                </template>
                
                <template v-slot:item.metodo="{ item }">
                  <v-chip 
                    :color="item.metodo === 'CRONOGRAMA_RETRY' ? undefined : getCorMetodo(item.metodo)" 
                    :style="getChipStyle(item.metodo)"
                    small 
                    outlined
                  >
                    {{ item.metodo }}
                  </v-chip>
                </template>
                
                <template v-slot:item.atualizado="{ item }">
                  <v-chip :color="item.atualizado ? 'success' : 'error'" small dark>
                    <v-icon small left>
                      {{ item.atualizado ? 'mdi-check' : 'mdi-close' }}
                    </v-icon>
                    {{ item.atualizado ? 'Sucesso' : 'Falha' }}
                  </v-chip>
                </template>
                
                <template v-slot:item.started_at="{ item }">
                  {{ formatarData(item.started_at) }}
                </template>
                
                <template v-slot:item.duracao="{ item }">
                  {{ formatarDuracao(item.duracao) }}
                </template>
                
                <template v-slot:item.base_size="{ item }">
                  {{ formatarTamanhoBase(item.base_size) }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Tabela de falhas -->
      <v-row class="mt-4">
        <v-col cols="12">
          <v-card>
            <v-card-title>
              <v-icon class="mr-2" color="error">mdi-alert-circle</v-icon>
              Falhas de Atualização
              <template v-if="ignorarFalhasComRetry && falhasOcultasPorRetry > 0">
                <v-chip
                  x-small
                  color="success"
                  class="ml-2"
                  title="Falhas ocultadas por terem retry bem-sucedido"
                >
                  {{ falhasOcultasPorRetry }} ocultadas
                </v-chip>
              </template>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchFalhas"
                append-icon="mdi-magnify"
                label="Pesquisar por nome do host"
                single-line
                hide-details
                clearable
                dense
                class="mt-0 pt-0"
                style="max-width: 300px;"
                @input="pesquisarFalhas"
              ></v-text-field>
            </v-card-title>
            <v-card-text>
              <!-- Mostrar mensagem quando filtro for apenas sucessos -->
              <div v-if="filtros.atualizado === true" class="text-center pa-8">
                <v-icon size="64" color="success" class="mb-4">mdi-check-circle</v-icon>
                <div class="text-h6 text-success mb-2">Filtro Aplicado: Apenas Sucessos</div>
                <div class="text-body-1 text--secondary">
                  Quando o filtro "Status = Sucessos" está ativo, não há falhas para exibir.
                  <br>
                  Use o filtro "Status = Falhas" ou "Status = Todos" para visualizar falhas de atualização.
                </div>
              </div>
              
              <!-- Mostrar tabela apenas quando não for filtro de apenas sucessos -->
              <div v-else>
                <v-data-table
                  :headers="headersFalhasFiltrados"
                  :items="falhasUnificadas || []"
                  :loading="loadingFalhas"
                  class="elevation-1"
                  item-key="idUnificado"
                >
                  <template v-slot:item.hostName="{ item }">
                    <v-chip 
                      small 
                      :style="(item.metodo === 'CRONOGRAMA' || item.metodo === 'CRONOGRAMA_RETRY') ? 'cursor: pointer;' : ''"
                      @click="(item.metodo === 'CRONOGRAMA' || item.metodo === 'CRONOGRAMA_RETRY') && abrirDialogConfigVideo(item)"
                    >
                      {{ item.hostName }}
                    </v-chip>
                  </template>
                  
                  <template v-slot:item.hostid="{ item }">
                    <v-chip x-small outlined :color="$vuetify.theme.dark ? 'light-blue' : 'primary'" class="font-weight-medium chip-hostid">
                      {{ item.hostid }}
                    </v-chip>
                  </template>
                  
                  <template v-slot:item.id="{ item }">
                    <v-chip x-small outlined :color="$vuetify.theme.dark ? 'teal' : 'secondary'" class="font-weight-medium chip-id">
                      {{ item.id }}
                    </v-chip>
                  </template>
                  
                  <template v-slot:item.sistema="{ item }">
                    <div class="d-flex align-center">
                      <img 
                        :src="getIconeSistema(item.sistema)" 
                        :alt="item.sistema"
                        class="sistema-icon"
                        :title="item.sistema"
                      />
                      <span class="ml-2">{{ item.sistema }}</span>
                    </div>
                  </template>
                  
                  <template v-slot:item.metodo="{ item }">
                    <div>
                      <v-chip 
                        :color="item.metodo === 'CRONOGRAMA_RETRY' ? undefined : getCorMetodo(item.metodo)" 
                        :style="getChipStyle(item.metodo)"
                        small 
                        outlined
                      >
                        {{ item.metodo }}
                      </v-chip>
                      <v-chip
                        v-if="item.retry && item.metodo === 'CRONOGRAMA' && item.retry.atualizado === false"
                        color="info"
                        x-small
                        class="ml-1"
                        outlined
                      >
                        <v-icon x-small left>mdi-refresh</v-icon>
                        Retry
                      </v-chip>
                    </div>
                  </template>
                  
                  <template v-slot:item.started_at="{ item }">
                    {{ formatarData(item.started_at) }}
                  </template>
                  
                  <template v-slot:item.duracao="{ item }">
                    {{ formatarDuracao(item.duracao) }}
                  </template>
                  
                  <template v-slot:item.base_size="{ item }">
                    {{ formatarTamanhoBase(item.base_size) }}
                  </template>
                  
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      small
                      color="primary"
                      @click="acessarLogs(item)"
                      :disabled="!item.dataFormatada"
                    >
                      <v-icon small left>mdi-file-document-outline</v-icon>
                      Ver Logs
                    </v-btn>
                    <v-btn
                      small
                      color="secondary"
                      class="ml-2"
                      @click="analisarLogIA(item)"
                      :loading="item.analisandoIA"
                      :disabled="!item.id"
                    >
                      <v-icon small left>mdi-brain</v-icon>
                      Analisar IA
                    </v-btn>
                    
                    <!-- Botão de comentário (apenas visualização) -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          :color="temComentario(item) ? 'info' : 'error'"
                          class="ml-2"
                          @click="verComentario(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon small color="white">mdi-comment-text</v-icon>
                    </v-btn>
                      </template>
                      <span>{{ temComentario(item) ? 'Ver Comentário' : 'Adicionar Comentário' }}</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Snackbar para notificações -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="5000">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
    
    <!-- Dashboard Log Viewer -->
    <dashboard-log-viewer
      v-model="logViewerDialog"
      :host-id="selectedLogItem.hostId"
      :host-name="selectedLogItem.hostName"
      :sistema="selectedLogItem.sistema"
      :data-formatada="selectedLogItem.dataFormatada"
      :atualizacao-id="selectedLogItem.atualizacaoId"
      @show-snackbar="mostrarNotificacao"
      @analisar-ia="abrirAnalisadorIA"
      @editar-comentario="editarComentario"
    />
    
    <!-- Dashboard IA Analyzer -->
    <dashboard-ia-analyzer
      v-model="iaAnalysisDialog"
      :atualizacao-id="selectedLogForAnalysis ? selectedLogForAnalysis.id : null"
      :host-id="selectedLogForAnalysis ? selectedLogForAnalysis.hostid : null"
      :host-name="selectedLogForAnalysis ? selectedLogForAnalysis.hostName : ''"
      :sistema="selectedLogForAnalysis ? selectedLogForAnalysis.sistema : ''"
      :data-formatada="selectedLogForAnalysis ? selectedLogForAnalysis.dataFormatada : ''"
      @show-snackbar="mostrarNotificacao"
    />
    
    <!-- Comentário Modal -->
    <comentario-modal
      ref="comentarioModal"
      v-model="comentarioDialog"
      :atualizacao="selectedComentarioItem"
      :atualizacaoRetry="selectedRetryItem"
      :modo="selectedComentarioItem?.modo || 'visualizar'"
      @comentario-salvo="onComentarioSalvo"
      @show-snackbar="mostrarNotificacao"
    />
    
    <!-- Dialog de Configuração de Vídeo -->
    <v-dialog v-model="dialogVideo" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">
          <v-icon class="mr-2">mdi-video</v-icon>
          Configurar Gravação de Vídeo
        </v-card-title>
        
        <v-card-text>
          <div v-if="dialogVideoLoading" class="text-center py-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <div class="mt-2">Carregando configuração...</div>
          </div>
          
          <div v-else>
            <div class="mb-4">
              <strong>Host:</strong> {{ dialogVideoHostName }}
            </div>
            
            <v-switch
              v-model="dialogVideoValue"
              :label="dialogVideoValue ? 'Gravação de vídeo ativada' : 'Gravação de vídeo desativada'"
              color="primary"
              hide-details
            ></v-switch>
            
            <div class="mt-4 text-caption text--secondary">
              <v-icon small class="mr-1">mdi-information</v-icon>
              Esta configuração se aplica apenas a atualizações do tipo CRONOGRAMA.
              Atualizações MANUAL e RETRY possuem gravação de vídeo nativa.
            </div>
          </div>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialogVideo = false"
            :disabled="dialogVideoSaving"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="salvarConfigVideo"
            :loading="dialogVideoSaving"
            :disabled="dialogVideoLoading"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dashboardService from '@/services/dashboardService'
import DashboardLogViewer from '@/components/DashboardLogViewer.vue'
import DashboardIaAnalyzer from '@/components/DashboardIaAnalyzer.vue'
import ComentarioModal from '@/components/ComentarioModal.vue'
import hostsService from '@/services/hostsService'
import Chart from 'chart.js/auto'
import * as XLSX from 'xlsx'

export default {
  name: 'DashboardView',
  
  components: {
    DashboardLogViewer,
    DashboardIaAnalyzer,
    ComentarioModal
  },
  
  data() {
    return {
      loading: false,
      loadingTabela: false,
      loadingFalhas: false,
      mostrarFiltros: false,
      menuDataInicio: false,
      menuDataFim: false,
      
      // Controle para filtros aplicados via URL
      filtrosAplicados: false,
      
      // Opção para ignorar falhas com retry bem-sucedido
      ignorarFalhasComRetry: true,
      
      // Controle de carregamento de dados de RETRY
      retryDataLoaded: false,
      retryBemSucedidoCache: new Set(),
      loadingRetryData: false,
      
      // Filtros
      filtros: {
        dataInicio: null,
        dataFim: null,
        horaInicio: null,
        horaFim: null,
        sistemas: [], // Agora um array para suportar múltiplos sistemas
        metodos: [], // Agora um array para suportar múltiplos métodos
        hostids: [], // Agora um array para suportar múltiplos hosts
        atualizado: null,
        finalizado: true, // Por padrão, mostrar apenas registros finalizados
        baseSizeMin: null, // Filtro de base mínima
        baseSizeMax: null  // Filtro de base máxima
      },
      
      // Campos de pesquisa
      searchHistorico: '',
      searchFalhas: '',
      searchTimeout: null,
      searchFalhasTimeout: null,
      
      // Opções para filtros
      opcoesFilters: {
        sistemas: [],
        hosts: [],
        metodos: []
      },
      
      // 2. ✅ Dados - SEMPRE arrays válidos (nunca null/undefined)
      estatisticas: {},
      atualizacoes: [], // SEMPRE array, nunca null
      falhas: [], // SEMPRE array, nunca null
      
      // Análise de IA
      iaAnalysisDialog: false,
      selectedLogForAnalysis: null,
      
      // Tabela
      optionsTabela: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['started_at'], // Ordenar por data de início por padrão
        sortDesc: [true], // Ordem decrescente (mais recente primeiro)
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      totalItens: 0,
      
      // Headers das tabelas
      headersAtualizacoes: [
        { text: 'Host', value: 'hostName' },
        { text: 'HostID', value: 'hostid', width: '100px' },
        { text: 'ID', value: 'id', width: '80px' },
        { text: 'Sistema', value: 'sistema' },
        { text: 'Base', value: 'base_size' },
        { text: 'Método', value: 'metodo' },
        { text: 'Versão Atual', value: 'versao_atual' },
        { text: 'Versão Final', value: 'versao_final' },
        { text: 'Status', value: 'atualizado' },
        { text: 'Iniciado em', value: 'started_at' },
        { text: 'Duração', value: 'duracao' }
      ],
      
      headersFalhas: [
        { text: 'Host', value: 'hostName' },
        { text: 'HostID', value: 'hostid', width: '100px' },
        { text: 'ID', value: 'id', width: '80px' },
        { text: 'Sistema', value: 'sistema' },
        { text: 'Base', value: 'base_size' },
        { text: 'Método', value: 'metodo' },
        { text: 'Versão Atual', value: 'versao_atual' },
        { text: 'Iniciado em', value: 'started_at' },
        { text: 'Duração', value: 'duracao' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      
      // Gráficos
      chartSistemas: null,
      chartSistemasPorHost: null,
      chartMetodos: null,
      chartMetodosPorHost: null,
      chartAtualizacoesPorcentagem: null,
      chartClientesPorcentagem: null,
      
      // Log Viewer
      logViewerDialog: false,
      selectedLogItem: {
        hostId: null,
        hostName: null,
        sistema: null,
        dataFormatada: null,
        atualizacaoId: null
      },
      
      // Comentário Modal
      comentarioDialog: false,
      selectedComentarioItem: null,
      selectedRetryItem: null,
      
      // Notificações
      snackbar: {
        show: false,
        text: '',
        color: 'info'
      },
      searchTimeout: null,
      
      // Controle de recriação de gráficos - MELHORADO
      graficosRecriando: false,
      graficosRecriarTimeout: null,
      graficosRecriarDebounce: 300,
      
      // NOVO: Controle de estado dos gráficos para evitar recriações desnecessárias
      graficosInicializados: false,
      dadosGraficosAtualizados: false,
      
      // NOVO: Controle robusto de estrutura dos gráficos
      graficosEstrutura: {
        sistemas: { 
          criado: false, 
          ultimaEstrutura: null,
          ultimosDados: null
        },
        metodos: { 
          criado: false, 
          ultimaEstrutura: null,
          ultimosDados: null
        },
        sistemasPorHost: { 
          criado: false, 
          ultimaEstrutura: null,
          ultimosDados: null
        }
      },
      
      // NOVO: Controle de quando os dados principais foram carregados
      dadosPrincipaisCarregados: false,
      
      // Dialog de configuração de vídeo
      dialogVideo: false,
      dialogVideoItem: null,
      dialogVideoHostId: null,
      dialogVideoHostName: '',
      dialogVideoValue: false,
      dialogVideoLoading: false,
      dialogVideoSaving: false,
      
      // Controle para datas com atualizações no calendário
      diasComAtualizacao: new Set(),
      carregandoDiasComAtualizacao: false,
      ultimoMesCarregado: null, // Para controlar qual mês foi carregado por último
      
      // Cache de dados por mês para evitar requisições repetidas
      cacheDiasComAtualizacao: {}, // Formato: { '2025-09': Set(['2025-09-01', '2025-09-02', ...]), ... }
      
      // Controle do mês visível nos calendários
      pickerMonthInicio: null,
      pickerMonthFim: null,
      
      // Range de base_size (valores mínimo e máximo disponíveis)
      baseSizeRange: {
        min: 0,
        max: 100
      },
      loadingBaseSizeRange: false,
      
      // Valor do slider de base_size (array com [min, max])
      baseSizeSliderValue: [0, 100],
      
      // Timeout para debug do slider (evitar spam de logs)
      debugSliderTimeout: null,
      
      // Indica se o slider está sendo arrastado (para feedback visual)
      isSliderActive: false,
      
      // NOVO: Controle de debouncing para grandes volumes
      filtroBaseSizeTimeout: null,
      processandoGrandeVolume: false,
      
      // Controle de exportação
      exportando: false
    }
  },
  
  computed: {
    filtrosAplicados() {
      return Object.values(this.filtros).some(valor => valor !== null && valor !== undefined)
    },
    falhasFiltradas() {
      try {
        // 2. ✅ Nenhuma lista pode ser null/undefined (sempre [])
      let falhasFiltradas = this.falhas;
        
        if (!falhasFiltradas || !Array.isArray(falhasFiltradas)) {
          return []; // SEMPRE retornar array vazio, nunca null/undefined
        }
        
        // Validação adicional: verificar se todos os itens são objetos válidos
        const itensValidos = falhasFiltradas.every((item, index) => {
          if (!item || typeof item !== 'object') {
            return false;
          }
          if (!item.id) {
            return false;
          }
          return true;
        });
        
        if (!itensValidos) {
          falhasFiltradas = falhasFiltradas.filter(item => 
            item && typeof item === 'object' && item.id
          );
        }
        
        // Filtrar apenas itens válidos
        falhasFiltradas = falhasFiltradas.filter(item => {
          if (!item || typeof item !== 'object') {
            return false;
          }
          if (!item.id) {
            return false;
          }
          return true;
        });
      
      // Iniciar o carregamento de RETRYs bem-sucedidos se ainda não foi feito
      if (this.ignorarFalhasComRetry && !this.retryDataLoaded) {
        this.carregarRetryBemSucedidos();
      }
      
      // Se a opção de ignorar falhas com retry bem-sucedido estiver ativada
      if (this.ignorarFalhasComRetry) {
        // Usar o cache de RETRYs bem-sucedidos se disponível
        const retryBemSucedido = new Set();
        
        // Se o cache já foi carregado, usamos ele
        if (this.retryDataLoaded) {
          // Copiar dados do cache
          this.retryBemSucedidoCache.forEach(chave => {
            retryBemSucedido.add(chave);
          });
        } else {
          // Se o cache ainda não foi carregado, usamos os dados disponíveis temporariamente
          // Fallback: usar os dados que já temos disponíveis
          const todasAtualizacoes = [...this.atualizacoes, ...this.falhas];
          
          // Removemos duplicatas baseadas no ID
          const atualizacoesUnicasTemp = todasAtualizacoes.filter((item, index, self) => 
            index === self.findIndex(t => t.id === item.id)
          );
          
          atualizacoesUnicasTemp.forEach(item => {
            if (item.metodo === 'CRONOGRAMA_RETRY' && item.atualizado === true) {
              // Criar uma chave composta de hostid + sistema + data (sem hora)
              const dataFormatada = this.extrairDataSemHora(item.started_at);
              const chave = `${item.hostid}_${item.sistema}_${dataFormatada}`;
              retryBemSucedido.add(chave);
            }
          });
        }
        
        // Filtra as falhas, removendo aquelas que têm um RETRY bem-sucedido
        const falhasAntes = falhasFiltradas.length;
        
        // Criar um mapa para rastrear os retries falhos
        const retryFalho = new Map();
        
        // Identificar todos os retries que falharam
        // Usar os dados disponíveis
        const todasAtualizacoesParaFalhos = [...this.atualizacoes, ...this.falhas];
        
        // Removemos duplicatas baseadas no ID
        const atualizacoesUnicasParaFalhos = todasAtualizacoesParaFalhos.filter((item, index, self) => 
          index === self.findIndex(t => t.id === item.id)
        );
        
        atualizacoesUnicasParaFalhos.forEach(item => {
          if (item.metodo === 'CRONOGRAMA_RETRY' && item.atualizado === false) {
            const dataFormatada = this.extrairDataSemHora(item.started_at);
            const chave = `${item.hostid}_${item.sistema}_${dataFormatada}`;
            retryFalho.set(chave, item.id);
          }
        });
        
        // Criar um relatório detalhado de cada falha e sua situação
        const relatorio = {
          ocultadas: [],
          mantidasComRetryFalho: [],
          mantidasSemRetry: [],
          outrosMetodos: []
        };
        
        falhasFiltradas = falhasFiltradas.filter(item => {
          // Se não é CRONOGRAMA, mantém na lista
          if (item.metodo !== 'CRONOGRAMA') {
            relatorio.outrosMetodos.push({
              id: item.id,
              hostName: item.hostName,
              hostId: item.hostid,
              sistema: item.sistema,
              metodo: item.metodo,
              data: this.extrairDataSemHora(item.started_at)
            });
            return true;
          }
          
          // Se é CRONOGRAMA, verifica se há um RETRY bem-sucedido ou falho
          const dataFormatada = this.extrairDataSemHora(item.started_at);
          const chave = `${item.hostid}_${item.sistema}_${dataFormatada}`;
          
          // Verificar se tem um retry bem-sucedido
          const temRetryBemSucedido = retryBemSucedido.has(chave);
          const temRetryFalho = retryFalho.has(chave);
          const retryId = temRetryFalho ? retryFalho.get(chave) : null;
          
          // Registrar no relatório
          if (temRetryBemSucedido) {
            relatorio.ocultadas.push({
              id: item.id,
              hostName: item.hostName,
              hostId: item.hostid,
              sistema: item.sistema,
              data: dataFormatada,
              motivo: `RETRY bem-sucedido encontrado para a mesma data/host/sistema`
            });
          } else if (temRetryFalho) {
            relatorio.mantidasComRetryFalho.push({
              id: item.id,
              hostName: item.hostName,
              hostId: item.hostid,
              sistema: item.sistema,
              data: dataFormatada,
              retryId: retryId,
              motivo: `RETRY também falhou (ID: ${retryId})`
            });
          } else {
            relatorio.mantidasSemRetry.push({
              id: item.id,
              hostName: item.hostName,
              hostId: item.hostid,
              sistema: item.sistema,
              data: dataFormatada,
              motivo: `Nenhum RETRY encontrado`
            });
          }
          
          // Retorna true para manter (se NÃO houver um retry bem-sucedido)
          return !temRetryBemSucedido;
        });
      }
      
      return falhasFiltradas;
      } catch (error) {
        console.error('Erro ao filtrar falhas:', error);
        console.error('Stack trace:', error.stack);
        return [];
      }
    },
    
    /**
     * Unifica as falhas de CRONOGRAMA com seus respectivos RETRYs
     * @returns {Array} Lista de falhas unificadas
     */
    falhasUnificadas() {
      try {
      // Primeiro obtemos as falhas filtradas normais
      const falhas = this.falhasFiltradas;
        
        if (!falhas || !Array.isArray(falhas)) {
          return [];
        }
      
      // Mapeamos as falhas para incluir informações de retry quando disponíveis
      const resultado = [];
      const retryMap = new Map(); // Mapa para armazenar os retrys por chave
      
      // Primeiro, separamos os itens em CRONOGRAMA e CRONOGRAMA_RETRY
      const cronogramas = [];
      const retrys = [];
      
      falhas.forEach(item => {
        if (item.metodo === 'CRONOGRAMA_RETRY') {
          retrys.push(item);
        } else {
          cronogramas.push(item);
        }
      });
      
      // Criamos um mapa de retrys para facilitar a busca
      retrys.forEach(retry => {
        const dataFormatada = this.extrairDataSemHora(retry.started_at);
        const chave = `${retry.hostid}_${retry.sistema}_${dataFormatada}`;
        retryMap.set(chave, retry);
      });
      
      // Agora processamos os cronogramas e adicionamos os retrys quando disponíveis
      cronogramas.forEach((cronograma, index) => {
        try {
          // Validação robusta do item
          if (!cronograma || typeof cronograma !== 'object') {
            return;
          }
          
          // Validar propriedades essenciais
          if (!cronograma.hostid || !cronograma.sistema || !cronograma.started_at) {
            return;
          }
          
        const dataFormatada = this.extrairDataSemHora(cronograma.started_at);
        // ✅ CHAVE MAIS ESPECÍFICA: incluir ID único e método para evitar duplicatas
        const chave = `${cronograma.hostid}_${cronograma.sistema}_${dataFormatada}`;
        const idUnico = `${chave}_${cronograma.metodo || 'CRONOGRAMA'}_${cronograma.id || index}_${Date.now()}`;
          
          // Validar se a chave foi criada corretamente
          if (!chave || chave.includes('undefined') || chave.includes('null')) {
            return;
          }
        
        // Criar um item unificado
        // Só adicionar retry se o método for CRONOGRAMA
        const retryEncontrado = cronograma.metodo === 'CRONOGRAMA' ? (retryMap.get(chave) || null) : null;
        
        const itemUnificado = {
          ...cronograma,
          idUnificado: idUnico, // ID único GARANTIDO para a linha
          retry: retryEncontrado // Adiciona o retry apenas se for CRONOGRAMA
        };
          
          // Validar o item unificado antes de adicionar
          if (!itemUnificado.idUnificado) {
            return;
          }
        
        resultado.push(itemUnificado);
        } catch (itemError) {
          // Erro ao processar cronograma - continuar com próximo item
        }
      });
      
      // Adicionar retrys que não têm um cronograma correspondente
      retrys.forEach((retry, index) => {
        try {
          // Validação robusta do retry
          if (!retry || typeof retry !== 'object') {
            return;
          }
          
          // Validar propriedades essenciais do retry
          if (!retry.hostid || !retry.sistema || !retry.started_at) {
            return;
          }
          
        const dataFormatada = this.extrairDataSemHora(retry.started_at);
        const chave = `${retry.hostid}_${retry.sistema}_${dataFormatada}`;
        // ✅ ID ÚNICO para retry: incluir método e timestamp para garantir unicidade
        const idUnicoRetry = `retry_${chave}_${retry.metodo || 'CRONOGRAMA_RETRY'}_${retry.id || index}_${Date.now()}`;
          
          // Validar se a chave foi criada corretamente
          if (!chave || chave.includes('undefined') || chave.includes('null')) {
            return;
          }
        
        // Verificar se já adicionamos este retry como parte de um cronograma (busca pela chave simples)
        const jaAdicionado = resultado.some(item => item.retry && item.retry.id === retry.id);
        
        if (!jaAdicionado) {
          // Criar um item para o retry sem cronograma correspondente
          const itemRetry = {
            ...retry,
            idUnificado: idUnicoRetry // ID único GARANTIDO para a linha
            };
            
            // Validar o item retry antes de adicionar
            if (!itemRetry.idUnificado) {
              return;
            }
          
          resultado.push(itemRetry);
          }
        } catch (retryError) {
          // Erro ao processar retry - continuar com próximo item
        }
      });
      
      // VALIDAÇÃO CRÍTICA: Garantir que TODOS os itens tenham key válida para Vue.js
      const resultadoValido = resultado.filter((item, index) => {
        // 1. ✅ Todas as props usadas como key existem em 100% dos itens?
        if (!item || typeof item !== 'object') {
          return false;
        }
        
        if (!item.idUnificado || typeof item.idUnificado !== 'string') {
          return false;
        }
        
        // Verificar se idUnificado é único e estável
        if (item.idUnificado.includes('undefined') || item.idUnificado.includes('null')) {
          return false;
        }
        
        return true;
      });
      
      // 2. ✅ Verificar se há duplicatas de key (Vue.js não aceita)
      const keysEncontradas = new Set();
      const resultadoSemDuplicatas = resultadoValido.filter((item, index) => {
        if (keysEncontradas.has(item.idUnificado)) {
          // Gerar nova key única para evitar duplicata (fallback de segurança)
          item.idUnificado = `${item.idUnificado}_fallback_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        }
        keysEncontradas.add(item.idUnificado);
        return true;
      });
      
      // 3. ✅ Garantir que sempre retorne array (nunca null/undefined)
      return resultadoSemDuplicatas || [];
      } catch (error) {
        console.error('Erro ao unificar falhas:', error);
        console.error('Stack trace:', error.stack);
        return [];
      }
    },
    headersFalhasFiltrados() {
      // Sempre mostrar a coluna Vídeo, mas o conteúdo será diferente baseado no método
      return this.headersFalhas
    },
    porcentagemSucesso() {
      const totalAtualizacoes = this.estatisticas.totalAtualizacoes || 0;
      const totalSucessos = this.estatisticas.totalSucessos || 0;
      return totalAtualizacoes > 0 ? ((totalSucessos / totalAtualizacoes) * 100).toFixed(1) : 0;
    },
    porcentagemFalha() {
      const totalAtualizacoes = this.estatisticas.totalAtualizacoes || 0;
      const totalFalhas = this.estatisticas.totalFalhas || 0;
      return totalAtualizacoes > 0 ? ((totalFalhas / totalAtualizacoes) * 100).toFixed(1) : 0;
    },
    
    /**
     * Calcula quantas falhas estão sendo ocultadas pelo filtro de retry
     */
    falhasOcultasPorRetry() {
      if (!this.ignorarFalhasComRetry || !this.falhas || this.falhas.length === 0) {
        return 0;
      }
      
      // Cria um conjunto de identificadores para atualizações CRONOGRAMA_RETRY bem-sucedidas
      const retryBemSucedido = new Set();
      
      // Usar o cache de RETRYs bem-sucedidos se disponível
      
      // Se o cache já foi carregado, usamos ele
      if (this.retryDataLoaded) {
        // Copiar dados do cache
        this.retryBemSucedidoCache.forEach(chave => {
          retryBemSucedido.add(chave);
        });
      } else {
        // Se o cache ainda não foi carregado, usamos os dados disponíveis temporariamente
        const todasAtualizacoes = [...this.atualizacoes, ...this.falhas];
        
        // Removemos duplicatas baseadas no ID
        const atualizacoesUnicas = todasAtualizacoes.filter((item, index, self) => 
          index === self.findIndex(t => t.id === item.id)
        );
        
        atualizacoesUnicas.forEach(item => {
          if (item.metodo === 'CRONOGRAMA_RETRY' && item.atualizado === true) {
            // Criar uma chave composta de hostid + sistema + data (sem hora)
            const dataFormatada = this.extrairDataSemHora(item.started_at);
            const chave = `${item.hostid}_${item.sistema}_${dataFormatada}`;
            retryBemSucedido.add(chave);
          }
        });
      }
      
      // Conta quantas falhas seriam ocultadas
      let contadorOcultadas = 0;
      const detalhesOcultadas = [];
      
      this.falhas.forEach(item => {
        // Apenas conta falhas de CRONOGRAMA
        if (item.metodo === 'CRONOGRAMA') {
          const dataFormatada = this.extrairDataSemHora(item.started_at);
          const chave = `${item.hostid}_${item.sistema}_${dataFormatada}`;
          
          if (retryBemSucedido.has(chave)) {
            contadorOcultadas++;
            detalhesOcultadas.push({
              id: item.id,
              hostName: item.hostName,
              hostId: item.hostid,
              sistema: item.sistema,
              data: dataFormatada
            });
          }
        }
      });
      
      // Exibir detalhes apenas se houver falhas ocultadas
      
      return contadorOcultadas;
    },
    
    /**
     * Estatísticas ajustadas - agora usa dados diretos do backend
     */
    estatisticasAjustadas() {
      // ===== MIGRAÇÃO: Usar dados diretos do backend =====
      // O backend agora já processa tudo corretamente, incluindo lógica de retry
      return {
        totalAtualizacoes: this.estatisticas.totalAtualizacoes || 0,
        totalSucessos: this.estatisticas.totalSucessos || 0,
        totalFalhas: this.estatisticas.totalFalhas || 0
      };
    },
    
    /**
     * Porcentagem de sucesso ajustada considerando falhas ocultadas
     */
    porcentagemSucessoAjustada() {
      // ===== MIGRAÇÃO: Usar dados diretos do backend =====
      const totalAtualizacoes = this.estatisticas.totalAtualizacoes || 0;
      const totalSucessos = this.estatisticas.totalSucessos || 0;
      return totalAtualizacoes > 0 ? ((totalSucessos / totalAtualizacoes) * 100).toFixed(1) : 0;
    },
    
    /**
     * Porcentagem de falha ajustada considerando falhas ocultadas
     */
    porcentagemFalhaAjustada() {
      // ===== MIGRAÇÃO: Usar dados diretos do backend =====
      const totalAtualizacoes = this.estatisticas.totalAtualizacoes || 0;
      const totalFalhas = this.estatisticas.totalFalhas || 0;
      return totalAtualizacoes > 0 ? ((totalFalhas / totalAtualizacoes) * 100).toFixed(1) : 0;
    },
    
    /**
     * Estatísticas por sistema ajustadas considerando falhas ocultadas
     */
    estatisticasPorSistemaAjustadas() {
      // ===== MIGRAÇÃO: Usar dados diretos do backend =====
      if (!this.estatisticas || typeof this.estatisticas !== 'object') {
        return [];
      }
      
      const dados = this.estatisticas.estatisticasPorSistema;
      if (!dados || !Array.isArray(dados)) {
        return []; // SEMPRE retornar array, nunca null
      }
      
      // 1. ✅ Verificar se todos os itens têm propriedades necessárias para evitar undefined
      const dadosValidados = dados.filter((item, index) => {
        if (!item || typeof item !== 'object') {
          console.error(`🚨 VALIDAÇÃO COMPUTED SISTEMAS - Item ${index} não é objeto:`, item);
          return false;
        }
        if (!item.sistema || item.sucessos === undefined || item.falhas === undefined) {
          console.error(`🚨 VALIDAÇÃO COMPUTED SISTEMAS - Item ${index} sem propriedades essenciais:`, {
            item,
            sistema: item.sistema,
            sucessos: item.sucessos,
            falhas: item.falhas
          });
          return false;
        }
        return true;
      });
      
      
      // Usar dados já validados (evitar dupla validação)
      return dadosValidados;
    },
    
    /**
     * Estatísticas por método ajustadas considerando falhas ocultadas
     */
    estatisticasPorMetodoAjustadas() {
      // 2. ✅ Nenhuma lista pode ser null/undefined (sempre [])
      if (!this.estatisticas || typeof this.estatisticas !== 'object') {
        return []; // SEMPRE retornar array, nunca null
      }
      
      const dados = this.estatisticas.estatisticasPorMetodo;
      if (!dados || !Array.isArray(dados)) {
        return []; // SEMPRE retornar array, nunca null
      }
      
      // 1. ✅ Verificar se todos os itens têm propriedades necessárias
      const dadosValidados = dados.filter((item, index) => {
        if (!item || typeof item !== 'object') {
          return false;
        }
        if (!item.metodo || item.total === undefined) {
          return false;
        }
        return true;
      });
      
      
      // Usar dados já validados (evitar dupla validação)
      return dadosValidados;
    },
    
    /**
     * Dados por cliente - agora usa dados diretos do backend
     */
    dadosPorClienteAjustados() {
      // ===== MIGRAÇÃO: Usar dados diretos do backend =====
      return {
        totalHostsUnicos: this.estatisticas.totalHostsUnicos || 0,
        hostsComSucesso: this.estatisticas.hostsComSucesso || 0,
        hostsComFalha: this.estatisticas.hostsComFalha || 0
      };
    }
  },
  
  watch: {
    // Observar mudanças no estado do modal de logs para limpar a URL quando fechado
    logViewerDialog(newVal, oldVal) {
      // Se o modal foi fechado (newVal = false) e estava aberto antes (oldVal = true)
      if (oldVal === true && newVal === false) {
        // Forçar a limpeza da URL (mesmo para links compartilhados)
        this.limparParametroLogview(true);
      }
    },
    
    // Observar mudanças no mês visível do calendário de início
    pickerMonthInicio(novoMes) {
      if (novoMes) {
        this.carregarDiasComAtualizacao(novoMes);
      }
    },
    
    // Observar mudanças no mês visível do calendário de fim
    pickerMonthFim(novoMes) {
      if (novoMes) {
        this.carregarDiasComAtualizacao(novoMes);
      }
    },
    
    // Observar quando os menus de data são abertos
    menuDataInicio(aberto) {
      if (aberto && this.pickerMonthInicio) {
        // Verificar se já carregamos dados para este mês
        if (this.ultimoMesCarregado !== this.pickerMonthInicio) {
          this.carregarDiasComAtualizacao(this.pickerMonthInicio);
        }
      }
    },
    
    menuDataFim(aberto) {
      if (aberto && this.pickerMonthFim) {
        // Verificar se já carregamos dados para este mês
        if (this.ultimoMesCarregado !== this.pickerMonthFim) {
          this.carregarDiasComAtualizacao(this.pickerMonthFim);
        }
      }
    },
    
    optionsTabela: {
      handler(newOptions, oldOptions) {
        // Evitar chamada dupla na inicialização
        if (oldOptions && (
          newOptions.page !== oldOptions.page ||
          newOptions.itemsPerPage !== oldOptions.itemsPerPage ||
          JSON.stringify(newOptions.sortBy) !== JSON.stringify(oldOptions.sortBy) ||
          JSON.stringify(newOptions.sortDesc) !== JSON.stringify(oldOptions.sortDesc)
        )) {
          // IMPORTANTE: Ordenação da tabela só afeta a TABELA, não os gráficos
          this.buscarAtualizacoes() // Será chamado sem argumentos, usando os filtros processados
          
          // REMOVIDO: Não atualizar gráficos quando ordenação da tabela muda
        }
      },
      deep: true
    },
    
    
    ignorarFalhasComRetry: {
      handler(newValue, oldValue) {
        // Se a opção mudou, apenas atualizar os gráficos se já estiverem inicializados
        if (newValue !== oldValue && this.graficosInicializados) {
          this.atualizarGraficosSeNecessario();
        }
      }
    },
    
    estatisticas: {
      handler(newValue, oldValue) {
        // Se as estatísticas mudaram e os gráficos estão inicializados, atualizar
        if (newValue !== oldValue && this.graficosInicializados) {
          this.dadosPrincipaisCarregados = true;
          this.atualizarGraficosSeNecessario();
        }
      },
      deep: true
    },
    
    falhas: {
      handler(newValue, oldValue) {
        // REMOVIDO: Mudanças na tabela de falhas não devem afetar gráficos
        // Os gráficos usam dados de ESTATÍSTICAS, não dados da TABELA
        // if (newValue !== oldValue && this.graficosInicializados) {
        //   this.atualizarGraficosSeNecessario();
        // }
      },
      deep: true
    },
    
    atualizacoes: {
      handler(newValue, oldValue) {
        // REMOVIDO: Mudanças na tabela de atualizações não devem afetar gráficos
        // Os gráficos usam dados de ESTATÍSTICAS, não dados da TABELA
        // if (newValue !== oldValue && this.graficosInicializados) {
        //   this.atualizarGraficosSeNecessario();
        // }
      },
      deep: true
    },
    
    retryBemSucedidoCache: {
      handler(newValue, oldValue) {
        // REMOVIDO: Cache de RETRYs afeta apenas dados da TABELA, não os gráficos
        // Os gráficos usam dados de ESTATÍSTICAS globais, não dados de retry da tabela
        // if (newValue !== oldValue && this.graficosInicializados) {
        //   this.atualizarGraficosSeNecessario();
        // }
      },
      deep: true
    },
    
    retryDataLoaded: {
      handler(newValue, oldValue) {
        // REMOVIDO: Status de carregamento de RETRYs afeta apenas dados da TABELA, não os gráficos
        // Os gráficos usam dados de ESTATÍSTICAS globais, não dados de retry da tabela
        // if (newValue !== oldValue && this.graficosInicializados && newValue === true) {
        //   this.atualizarGraficosSeNecessario();
        // }
      }
    },
    
    falhasOcultasPorRetry: {
      handler(newValue, oldValue) {
        // REMOVIDO: Falhas ocultadas por retry afeta apenas dados da TABELA, não os gráficos
        // Os gráficos usam dados de ESTATÍSTICAS globais, não dados de retry da tabela
        // if (newValue !== oldValue && this.graficosInicializados) {
        //   this.atualizarGraficosSeNecessario();
        // }
      }
    },
    
    estatisticasAjustadas: {
      handler(newValue, oldValue) {
        // Se as estatísticas ajustadas mudaram e os gráficos estão inicializados, atualizar
        if (newValue !== oldValue && this.graficosInicializados) {
          this.atualizarGraficosSeNecessario();
        }
      },
      deep: true
    },
    
    porcentagemSucessoAjustada: {
      handler(newValue, oldValue) {
        // Se a porcentagem de sucesso ajustada mudou e os gráficos estão inicializados, atualizar
        if (newValue !== oldValue && this.graficosInicializados) {
          this.atualizarGraficosSeNecessario();
        }
      }
    },
    
    porcentagemFalhaAjustada: {
      handler(newValue, oldValue) {
        // Se a porcentagem de falha ajustada mudou e os gráficos estão inicializados, atualizar
        if (newValue !== oldValue && this.graficosInicializados) {
          this.atualizarGraficosSeNecessario();
        }
      }
    },
    
    // Computed properties que dependem das estatísticas ajustadas
    falhasFiltradas: {
      handler(newValue, oldValue) {
        // REMOVIDO: falhasFiltradas é para a tabela, não para gráficos
        // Os gráficos usam dados de ESTATÍSTICAS, não dados filtrados da TABELA
        // if (newValue !== oldValue && this.graficosInicializados) {
        //   this.atualizarGraficosSeNecessario();
        // }
      },
      deep: true
    },
    
    falhasUnificadas: {
      handler(newValue, oldValue) {
        // REMOVIDO: falhasUnificadas é para a tabela, não para gráficos
        // Os gráficos usam dados de ESTATÍSTICAS, não dados unificados da TABELA
        // if (newValue !== oldValue && this.graficosInicializados) {
        //   this.atualizarGraficosSeNecessario();
        // }
      },
      deep: true
    },
    
    // Computed properties que dependem das estatísticas ajustadas
    headersFalhasFiltrados: {
      handler(newValue, oldValue) {
        // REMOVIDO: Headers são elementos de UI, não devem afetar gráficos
        // if (newValue !== oldValue && this.graficosInicializados) {
        //   this.atualizarGraficosSeNecessario();
        // }
      },
      deep: true
    },
    
    // Computed properties que dependem das estatísticas ajustadas
    filtrosAplicados: {
      handler(newValue, oldValue) {
        // Se os filtros aplicados mudaram e os gráficos estão inicializados, atualizar
        if (newValue !== oldValue && this.graficosInicializados) {
          this.atualizarGraficosSeNecessario();
        }
      }
    },
    
    estatisticasPorSistemaAjustadas: {
      handler(newValue, oldValue) {
        // Se as estatísticas por sistema ajustadas mudaram e os gráficos estão inicializados, atualizar
        if (newValue !== oldValue && this.graficosInicializados) {
          this.atualizarGraficosSeNecessario();
        }
      },
      deep: true
    },
    
    estatisticasPorMetodoAjustadas: {
      handler(newValue, oldValue) {
        // Se as estatísticas por método ajustadas mudaram e os gráficos estão inicializados, atualizar
        if (newValue !== oldValue && this.graficosInicializados) {
          this.atualizarGraficosSeNecessario();
        }
      },
      deep: true
    },
    
    // Computed properties que dependem das estatísticas ajustadas
    searchHistorico: {
      handler(newValue, oldValue) {
        // REMOVIDO: Pesquisa do histórico afeta apenas a TABELA, não os gráficos
        // Os gráficos usam dados de ESTATÍSTICAS globais
        // if (newValue !== oldValue && this.graficosInicializados) {
        //   this.atualizarGraficosSeNecessario();
        // }
      }
    },
    
    // Watcher para atualizar cores dos gráficos quando o tema mudar
    '$vuetify.theme.dark': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue && this.graficosInicializados) {
          // Recriar gráficos com novas cores baseadas no tema
          this.$nextTick(() => {
            if (this.chartMetodos) {
              this.criarGraficoMetodos();
            }
            if (this.chartMetodosPorHost) {
              this.criarGraficoMetodosPorHost();
            }
          });
        }
      }
    },
    
    // Computed properties que dependem das estatísticas ajustadas
    searchFalhas: {
      handler(newValue, oldValue) {
        // Se a pesquisa das falhas mudou, executar pesquisa
        if (newValue !== oldValue) {
          this.pesquisarFalhas();
        }
      }
    },
    
    // Watchers para sincronizar campos de base_size com o slider
    'filtros.baseSizeMin': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.updateSliderFromInput();
        }
      }
    },
    
    'filtros.baseSizeMax': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.updateSliderFromInput();
        }
      }
    },
    
    // Watcher para o range de base_size (quando carregado da API)
    baseSizeRange: {
      handler(newRange, oldRange) {
        if (newRange && (!oldRange || newRange.min !== oldRange.min || newRange.max !== oldRange.max)) {
          // Atualizar o slider quando o range é carregado/alterado
          this.baseSizeSliderValue = [newRange.min, newRange.max];
        }
      },
      deep: true
    },
    

  },
  
  async mounted() {
    // Adicionar handler global para erros do Vue
    this.$options.errorCaptured = (err, vm, info) => {
      console.error('🚨 Erro capturado no componente Dashboard:', {
        error: err,
        errorInfo: info,
        component: vm?.$options?.name || 'Unknown',
        stack: err.stack
      });
      
      // VALIDAÇÃO ESPECÍFICA: Se o erro contém 'key', verificar integridade dos dados
      if (err.message && err.message.includes('key')) {
        console.error('🚨 ERRO DE KEY DETECTADO - Executando diagnóstico completo...');
        
        // Verificar integridade dos dados
        const integridadeOk = this.verificarIntegridadeDados();
        
        if (!integridadeOk) {
          console.error('🚨 PROBLEMA DE INTEGRIDADE - Limpando dados problemáticos...');
          // Limpar dados que podem estar causando problema
          this.falhas = [];
          this.atualizacoes = [];
          this.$nextTick(() => {
            this.aplicarFiltros();
          });
        }
      }
      
      // Tentar recuperar resetando os gráficos
      if (info.includes('render') || info.includes('patch')) {
        this.graficosInicializados = false;
        this.$nextTick(() => {
          this.criarGraficos();
        });
      }
      
      // Não propagar o erro para evitar crash total
      return false;
    };
    
    // Inicializar os meses dos calendários com o mês atual
    const now = new Date();
    const anoMes = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    
    // Inicializar ambos os calendários com o mês atual
    this.pickerMonthInicio = anoMes;
    this.pickerMonthFim = anoMes;
    
    try {
    await this.inicializar();
    } catch (error) {
      console.error('Erro durante inicialização:', error);
    }
    
    // Carregar informações de datas com atualizações ao montar o componente
    // para o mês atual (será usado por ambos os calendários inicialmente)
    this.carregarDiasComAtualizacao(anoMes);
  },
  
  beforeDestroy() {
    this.destruirGraficos()
    
    // Limpar timeout de pesquisa
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
    
    // Limpar timeout de recriação de gráficos
    if (this.graficosRecriarTimeout) {
      clearTimeout(this.graficosRecriarTimeout)
    }
    
    // Limpar timeout de debug do slider
    if (this.debugSliderTimeout) {
      clearTimeout(this.debugSliderTimeout)
    }
    
    // Limpar timeout de filtro de base_size
    if (this.filtroBaseSizeTimeout) {
      clearTimeout(this.filtroBaseSizeTimeout)
    }
  },
  
  methods: {
    // Função para obter a data atual no formato YYYY-MM-DD
    obterDataAtual() {
      const hoje = new Date()
      const ano = hoje.getFullYear()
      const mes = String(hoje.getMonth() + 1).padStart(2, '0')
      const dia = String(hoje.getDate()).padStart(2, '0')
      return `${ano}-${mes}-${dia}`
    },

    // Função para obter data de início a partir de uma data
    obterDataInicio(dataString) {
      if (!dataString) return this.obterDataAtual()
      const data = new Date(dataString)
      const ano = data.getFullYear()
      const mes = String(data.getMonth() + 1).padStart(2, '0')
      const dia = String(data.getDate()).padStart(2, '0')
      return `${ano}-${mes}-${dia}`
    },

    // Função para obter data de fim a partir de uma data
    obterDataFim(dataString) {
      if (!dataString) return this.obterDataAtual()
      const data = new Date(dataString)
      const ano = data.getFullYear()
      const mes = String(data.getMonth() + 1).padStart(2, '0')
      const dia = String(data.getDate()).padStart(2, '0')
      return `${ano}-${mes}-${dia}`
    },

    async inicializar() {
      this.loading = true
      try {
        // Verificar se há parâmetros na URL
        await this.verificarParametrosUrl()
        
        // Se não houver parâmetros na URL, usar datas padrão
        if (!this.filtrosAplicados) {
          // Definir datas padrão como o dia atual
          const dataAtual = this.obterDataAtual()
          this.filtros.dataInicio = dataAtual
          this.filtros.dataFim = dataAtual
          
          await Promise.all([
            this.buscarOpcoesFilters(),
            this.buscarBaseSizeRange()
          ])
          await this.buscarDados()
        }
        
        // Se a opção de ignorar falhas estiver ativa, carregar dados de RETRY bem-sucedidos
        if (this.ignorarFalhasComRetry) {
          await this.carregarRetryBemSucedidos();
        }
      } catch (error) {
        this.mostrarNotificacao('Erro ao carregar dados do dashboard', 'error')
        console.error('Erro ao inicializar dashboard:', error)
      } finally {
        this.loading = false
      }
    },
    
    /**
     * Verifica se existem parâmetros na URL (logview e filtros)
     * e os aplica para exibir a atualização correta
     */
    async verificarParametrosUrl() {
      try {
        // Verificar se há parâmetro logview na URL
        const hashParts = window.location.hash.split('?')
        if (hashParts.length < 2) {
          return false // Não há parâmetros
        }
        
        const urlParams = new URLSearchParams(hashParts[1])
        const logviewId = urlParams.get('logview')
        const filtrosParam = urlParams.get('filtros')
        
        // Se não há parâmetros relevantes, não fazer nada
        if (!logviewId && !filtrosParam) {
          return false
        }
        
        // Variável para controlar se os filtros foram aplicados com sucesso
        let filtrosAplicados = false
        
        // Primeiro buscar opções de filtros e range de base_size para ter dados para seleção
        await Promise.all([
          this.buscarOpcoesFilters(),
          this.buscarBaseSizeRange()
        ])
        
        // Se houver filtros na URL, aplicá-los primeiro
        if (filtrosParam) {
          try {
            const filtrosDeserializados = JSON.parse(decodeURIComponent(filtrosParam))
            
            // Aplicar os filtros recebidos aos filtros atuais
            if (filtrosDeserializados) {
              // Aplicar data de início e fim (se fornecidas)
              if (filtrosDeserializados.dataInicio) {
                this.filtros.dataInicio = filtrosDeserializados.dataInicio
                
                // Se a data tiver formato ISO completo (com T), extrair apenas a data
                if (this.filtros.dataInicio.includes('T')) {
                  this.filtros.dataInicio = this.filtros.dataInicio.split('T')[0]
                }
              }
              
              if (filtrosDeserializados.dataFim) {
                this.filtros.dataFim = filtrosDeserializados.dataFim
                
                // Se a data tiver formato ISO completo (com T), extrair apenas a data
                if (this.filtros.dataFim.includes('T')) {
                  this.filtros.dataFim = this.filtros.dataFim.split('T')[0]
                }
              }
              
              // Aplicar hostid (se fornecido)
              if (filtrosDeserializados.hostid) {
                // Buscar o host nos dados disponíveis
                if (this.opcoesFilters && this.opcoesFilters.hosts) {
                  const host = this.opcoesFilters.hosts.find(h => h.hostId === filtrosDeserializados.hostid)
                  if (host) {
                    this.filtros.hostids = [host]
                  } else {
                    // Se o host não estiver nas opções, criar um objeto temporário
                    this.filtros.hostids = [{
                      hostId: filtrosDeserializados.hostid,
                      name: `Host ${filtrosDeserializados.hostid}`
                    }]
                  }
                } else {
                  // Se não tivermos as opções de hosts, criar um objeto temporário
                  this.filtros.hostids = [{
                    hostId: filtrosDeserializados.hostid,
                    name: `Host ${filtrosDeserializados.hostid}`
                  }]
                }
              }
              
              // Aplicar sistema (se fornecido)
              if (filtrosDeserializados.sistema) {
                this.filtros.sistemas = [filtrosDeserializados.sistema]
              }
              
              // Carregar os dados com os filtros aplicados
              await this.buscarDados()
              
              // Marcar que os filtros foram aplicados com sucesso
              filtrosAplicados = true
              this.filtrosAplicados = true
            }
          } catch (error) {
            console.error('Erro ao aplicar filtros da URL:', error)
          }
        }
        
        // Se não há parâmetro logview, não prosseguir para abrir o modal
        if (!logviewId) {
          return filtrosAplicados
        }
        
        // Converter para número (ID da atualização)
        const atualizacaoId = parseInt(logviewId, 10)
        
        if (!isNaN(atualizacaoId)) {
          
          // Buscar dados da atualização
          try {
            const response = await dashboardService.getLogAtualizacao(atualizacaoId)
            
            if (response && response.controle) {
              const atualizacao = response.controle
              
              // Formatar a data para o formato esperado pelo logviewer (DD.MM.YYYY)
              let dataFormatada = null
              if (atualizacao.started_at) {
                try {
                  const data = new Date(atualizacao.started_at)
                  const dia = String(data.getDate()).padStart(2, '0')
                  const mes = String(data.getMonth() + 1).padStart(2, '0')
                  const ano = data.getFullYear()
                  dataFormatada = `${dia}.${mes}.${ano}`
                } catch (error) {
                  console.error('Erro ao formatar data:', error)
                }
              }
              
              if (dataFormatada) {
                // Buscar informações adicionais do host se necessário
                let hostName = atualizacao.hostName || null;
                
                // Se não temos o nome do host, mas temos o hostId, vamos buscar o nome
                if (!hostName && atualizacao.hostid) {
                  try {
                    // Primeiro verificar se já temos o host nas opções de filtro
                    if (this.opcoesFilters && this.opcoesFilters.hosts) {
                      const hostEncontrado = this.opcoesFilters.hosts.find(h => h.hostId === atualizacao.hostid.toString());
                      if (hostEncontrado) {
                        hostName = hostEncontrado.name;
                      }
                    }
                    
                    // Se ainda não encontramos o nome, buscar da API
                    if (!hostName) {
                      const hostResponse = await hostsService.getHostByZabbixId(atualizacao.hostid);
                      if (hostResponse && hostResponse.name) {
                        hostName = hostResponse.name;
                      }
                    }
                  } catch (error) {
                    console.error('Erro ao buscar informações do host:', error);
                  }
                }
                
                // Configurar o item selecionado para o log viewer
                this.selectedLogItem = {
                  hostId: atualizacao.hostid.toString(),
                  hostName: hostName || 'Host não identificado',
                  sistema: atualizacao.sistema || 'Sistema não identificado',
                  dataFormatada: dataFormatada,
                  atualizacaoId: atualizacaoId
                }
                
                // Abrir o log viewer
                this.logViewerDialog = true
                
                // Não limpar os parâmetros da URL quando abrimos o modal a partir de um link compartilhado
                // Isso mantém a URL original para referência e compartilhamento
                
                return true
              } else {
                this.mostrarNotificacao('Não foi possível determinar a data da atualização', 'error')
              }
            } else {
              this.mostrarNotificacao('Dados da atualização não encontrados', 'error')
            }
          } catch (error) {
            console.error('Erro ao buscar dados da atualização:', error)
            this.mostrarNotificacao('Erro ao buscar dados da atualização', 'error')
          }
        } else {
          this.mostrarNotificacao('ID de atualização inválido', 'error')
        }
        
        return filtrosAplicados
      } catch (error) {
        console.error('Erro ao verificar parâmetros da URL:', error)
        return false
      }
    },
    
    /**
     * Limpa o cache de dias com atualizações
     * Útil quando os filtros são alterados e os dados precisam ser recarregados
     */
    limparCacheDiasComAtualizacao() {
      this.cacheDiasComAtualizacao = {};
      this.ultimoMesCarregado = null;
    },
    
    /**
     * Remove os parâmetros da URL sem recarregar a página
     * @param {boolean} force - Se true, força a remoção mesmo em casos especiais
     */
    limparParametroLogview(force = false) {
      // Verificar se a URL atual contém parâmetros de logview
      const urlAtual = window.location.hash;
      const isSharedLink = urlAtual.includes('logview=') && urlAtual.includes('filtros=');
      
      // Se for um link compartilhado e não estamos forçando a limpeza, preservar a URL
      if (isSharedLink && !force) {
        return;
      }
      
      // Caso contrário, limpar os parâmetros normalmente
      if (history.pushState) {
        const newUrl = window.location.pathname + window.location.hash.split('?')[0];
        history.pushState({ path: newUrl }, '', newUrl);
      }
    },
    
    async buscarOpcoesFilters() {
      try {
        const response = await dashboardService.getOpcoesFilters()
        
        if (response.success) {
          this.opcoesFilters = response.opcoes
        }
      } catch (error) {
        // Erro ao buscar opções de filtros
      }
    },
    
    async buscarBaseSizeRange() {
      this.loadingBaseSizeRange = true
      try {
        // Passar as datas dos filtros para o backend considerar no cálculo do range
        const dataInicio = this.filtros.dataInicio || null
        const dataFim = this.filtros.dataFim || null
        
        const response = await dashboardService.getBaseSizeRange(dataInicio, dataFim)
        
        if (response.success && response.range) {
          this.baseSizeRange = response.range
          // Inicializar o slider com os valores do range
          this.baseSizeSliderValue = [this.baseSizeRange.min, this.baseSizeRange.max]
          // Inicializar os filtros com os valores mínimo e máximo
          if (this.filtros.baseSizeMin === null || this.filtros.baseSizeMin === undefined) {
            this.filtros.baseSizeMin = this.baseSizeRange.min
          }
          if (this.filtros.baseSizeMax === null || this.filtros.baseSizeMax === undefined) {
            this.filtros.baseSizeMax = this.baseSizeRange.max
          }
        }
      } catch (error) {
        console.error('Erro ao buscar range de base_size:', error)
        // Manter valores padrão em caso de erro
      } finally {
        this.loadingBaseSizeRange = false
      }
    },
    
    /**
     * Atualiza os filtros em tempo real enquanto arrasta o slider (sem aplicar filtros)
     */
    updateBaseSizeFiltersRealTime(sliderValue) {
      if (sliderValue && Array.isArray(sliderValue) && sliderValue.length === 2) {
        // Arredondar para 1 casa decimal
        const minValue = Math.round(sliderValue[0] * 10) / 10
        const maxValue = Math.round(sliderValue[1] * 10) / 10
        
        // Atualizar apenas os valores visuais (não aplicar filtros ainda)
        if (minValue === this.baseSizeRange.min && maxValue === this.baseSizeRange.max) {
          this.filtros.baseSizeMin = null
          this.filtros.baseSizeMax = null
        } else {
          this.filtros.baseSizeMin = minValue
          this.filtros.baseSizeMax = maxValue
        }
        
        // Log apenas para debug (sem spam excessivo)
        if (this.debugSliderTimeout) {
          clearTimeout(this.debugSliderTimeout)
        }
      }
    },
    
    /**
     * Atualiza os filtros quando o slider para de ser arrastado (aplica filtros)
     * COM DEBOUNCING para grandes volumes de dados
     */
    updateBaseSizeFilters(sliderValue) {
      // Limpar timeout anterior se existir
      if (this.filtroBaseSizeTimeout) {
        clearTimeout(this.filtroBaseSizeTimeout);
      }
      
      // Se está processando grande volume, usar debouncing mais longo
      const delayDebouncing = this.processandoGrandeVolume ? 1000 : 300;
      
      
      // Aplicar debouncing
      this.filtroBaseSizeTimeout = setTimeout(() => {
        this.aplicarFiltroBaseSizeInterno(sliderValue);
      }, delayDebouncing);
    },
    
    /**
     * Aplica o filtro de base_size internamente
     */
    aplicarFiltroBaseSizeInterno(sliderValue) {
      if (sliderValue && Array.isArray(sliderValue) && sliderValue.length === 2) {
        // Arredondar para 1 casa decimal
        const minValue = Math.round(sliderValue[0] * 10) / 10
        const maxValue = Math.round(sliderValue[1] * 10) / 10
        
        // Se os valores do slider são iguais ao range completo, limpar os filtros
        if (minValue === this.baseSizeRange.min && maxValue === this.baseSizeRange.max) {
          this.filtros.baseSizeMin = null
          this.filtros.baseSizeMax = null
        } else {
          this.filtros.baseSizeMin = minValue
          this.filtros.baseSizeMax = maxValue
        }
      }
    },
    
    /**
     * Atualiza o slider quando os campos de input mudam
     */
    updateSliderFromInput() {
      // Evitar loops infinitos verificando se os valores realmente mudaram
      const currentMin = this.baseSizeSliderValue[0]
      const currentMax = this.baseSizeSliderValue[1]
      
      // Usar valores dos campos ou valores padrão do range
      let min = this.filtros.baseSizeMin !== null && this.filtros.baseSizeMin !== undefined && this.filtros.baseSizeMin !== ''
        ? parseFloat(this.filtros.baseSizeMin) 
        : this.baseSizeRange.min
        
      let max = this.filtros.baseSizeMax !== null && this.filtros.baseSizeMax !== undefined && this.filtros.baseSizeMax !== ''
        ? parseFloat(this.filtros.baseSizeMax) 
        : this.baseSizeRange.max
      
      // Garantir que os valores estão dentro do range válido
      min = Math.max(this.baseSizeRange.min, Math.min(this.baseSizeRange.max, min))
      max = Math.max(this.baseSizeRange.min, Math.min(this.baseSizeRange.max, max))
      
      // Garantir que min não seja maior que max
      if (min > max) {
        [min, max] = [max, min] // Trocar valores
      }
      
      // Arredondar para 1 casa decimal
      const validMin = Math.round(min * 10) / 10
      const validMax = Math.round(max * 10) / 10
      
      // Só atualizar se os valores realmente mudaram (evita loops)
      if (currentMin !== validMin || currentMax !== validMax) {
        this.baseSizeSliderValue = [validMin, validMax]
      }
    },
    
    async buscarDados() {
      // Processar filtros para incluir horas
      const filtrosProcessados = this.processarFiltros()
      
      // Usar filtros processados para estatísticas e falhas (não precisam de paginação)
      await Promise.all([
        this.buscarEstatisticas(filtrosProcessados),
        this.buscarFalhas(filtrosProcessados)
      ])
      
      // Buscar atualizações com paginação usando filtros processados
      await this.buscarAtualizacoes(filtrosProcessados)
    },
    
    async buscarEstatisticas(filtros = this.filtros) {
      try {
        const response = await dashboardService.getEstatisticas(filtros, this.ignorarFalhasComRetry)
        
        if (response.success) {
          
          // Validar estrutura das estatísticas antes de atribuir
          if (!response.estatisticas || typeof response.estatisticas !== 'object') {
            console.error('🚨 Estatísticas inválidas recebidas:', response.estatisticas);
            return;
          }
          
          // Validar arrays críticos
          if (response.estatisticas.estatisticasPorSistema && !Array.isArray(response.estatisticas.estatisticasPorSistema)) {
            console.error('🚨 estatisticasPorSistema não é array:', response.estatisticas.estatisticasPorSistema);
            response.estatisticas.estatisticasPorSistema = [];
          }
          
          if (response.estatisticas.estatisticasPorMetodo && !Array.isArray(response.estatisticas.estatisticasPorMetodo)) {
            console.error('🚨 estatisticasPorMetodo não é array:', response.estatisticas.estatisticasPorMetodo);
            response.estatisticas.estatisticasPorMetodo = [];
          }
          
          // CRÍTICO: Validar arrays de sistemas por host
          if (response.estatisticas.estatisticasPorSistemaPorHost && !Array.isArray(response.estatisticas.estatisticasPorSistemaPorHost)) {
            console.error('🚨 estatisticasPorSistemaPorHost não é array:', response.estatisticas.estatisticasPorSistemaPorHost);
            response.estatisticas.estatisticasPorSistemaPorHost = [];
          }
          
          if (response.estatisticas.estatisticasPorMetodoPorHost && !Array.isArray(response.estatisticas.estatisticasPorMetodoPorHost)) {
            console.error('🚨 estatisticasPorMetodoPorHost não é array:', response.estatisticas.estatisticasPorMetodoPorHost);
            response.estatisticas.estatisticasPorMetodoPorHost = [];
          }
          
          // Garantir que os arrays existem mesmo que vazios
          if (!response.estatisticas.estatisticasPorSistemaPorHost) {
            response.estatisticas.estatisticasPorSistemaPorHost = [];
          }
          
          if (!response.estatisticas.estatisticasPorMetodoPorHost) {
            response.estatisticas.estatisticasPorMetodoPorHost = [];
          }
          
          this.estatisticas = response.estatisticas
          
          // Aguardar um pouco para garantir que o DOM está pronto
          await this.$nextTick()
          
          // Verificar se os dados existem antes de criar os gráficos
          if (this.estatisticas.estatisticasPorSistema && Array.isArray(this.estatisticas.estatisticasPorSistema)) {
            // Dados por sistema disponíveis
          }
          
          if (this.estatisticas.estatisticasPorMetodo && Array.isArray(this.estatisticas.estatisticasPorMetodo)) {
            // Dados por método disponíveis
          }
          
          // SEMPRE criar os gráficos quando receber estatísticas (filtros aplicados)
          // Isso garante que os gráficos sejam criados na primeira vez
          try {
            // Verificação adicional antes de criar gráficos
            if (!this.estatisticas.estatisticasPorSistema) {
              this.estatisticas.estatisticasPorSistema = [];
            }
            if (!this.estatisticas.estatisticasPorMetodo) {
              this.estatisticas.estatisticasPorMetodo = [];
            }
            
          this.criarGraficos()
          this.graficosInicializados = true;
          } catch (graficoError) {
            console.error('Erro ao criar gráficos:', graficoError);
            
            // Reset completo em caso de erro
            this.graficosInicializados = false;
            this.destruirGraficos();
          }
          
          // Marcar que os dados principais foram carregados
          this.dadosPrincipaisCarregados = true;
        }
      } catch (error) {
        // Erro ao buscar estatísticas
      }
    },
    
    async buscarAtualizacoes(filtros = null) {
      this.loadingTabela = true
      try {
        // Sempre processar os filtros antes de enviar
        const filtrosProcessados = filtros || this.processarFiltros()
        
        // Processar ordenação
        let sortBy = null
        let sortDesc = false
        
        if (this.optionsTabela.sortBy && this.optionsTabela.sortBy.length > 0) {
          sortBy = this.optionsTabela.sortBy[0]
          sortDesc = this.optionsTabela.sortDesc && this.optionsTabela.sortDesc.length > 0 
            ? this.optionsTabela.sortDesc[0] 
            : false
        }
        
        const response = await dashboardService.getAtualizacoes(
          filtrosProcessados,
          this.optionsTabela.page,
          this.optionsTabela.itemsPerPage,
          this.searchHistorico,
          false, // Sempre false para histórico - mostra todas as atualizações
          sortBy,
          sortDesc
        )
        
        if (response.success) {
          // CRÍTICO: Validar se response.atualizacoes é um array válido antes de usar .map()
          if (!response.atualizacoes || !Array.isArray(response.atualizacoes)) {
            console.error('Erro crítico: response.atualizacoes não é um array válido');
            this.atualizacoes = [];
            return;
          }
          
          // OTIMIZAÇÃO: Para grandes volumes de dados, processar em lotes
          const TAMANHO_LOTE = 50; // Processar 50 itens por vez
          const totalItens = response.atualizacoes.length;
          
          if (totalItens > TAMANHO_LOTE) {
            await this.processarAtualizacoesEmLotes(response.atualizacoes, TAMANHO_LOTE);
            } else {
            await this.processarAtualizacoesDireto(response.atualizacoes);
          }
          
          this.totalItens = response.total
          
          // REMOVIDO: Não atualizar gráficos quando dados da tabela mudam
          // Os gráficos usam dados de ESTATÍSTICAS, não dados da TABELA
          // A ordenação da tabela não deve afetar os gráficos
          // if (this.graficosInicializados && this.dadosPrincipaisCarregados) {
          //   this.atualizarGraficosSeNecessario();
          // }
        }
      } catch (error) {
        // Erro ao buscar atualizações
      } finally {
        this.loadingTabela = false
      }
    },
    
    async buscarFalhas(filtros = null) {
      this.loadingFalhas = true
      try {
        // Sempre processar os filtros antes de enviar
        const filtrosProcessados = filtros || this.processarFiltros()
        
        // Falhas de atualização não usa paginação - retorna todos os dados
        const response = await dashboardService.getFalhas(
          filtrosProcessados, 
          this.ignorarFalhasComRetry, 
          this.searchFalhas
        )
        if (response.success) {
          // CRÍTICO: Validar se response.falhas é um array válido antes de usar .map()
          if (!response.falhas || !Array.isArray(response.falhas)) {
            console.error('Erro crítico: response.falhas não é um array válido');
            this.falhas = [];
            return;
          }
          
          // Processar falhas diretamente (retorna todos os dados, sem paginação)
          await this.processarFalhasDireto(response.falhas);
          
          // REMOVIDO: Buscar falhas afeta apenas a TABELA, não os gráficos
          // Os gráficos usam dados de ESTATÍSTICAS globais, não dados filtrados da tabela de falhas
          // A pesquisa de falhas é apenas para filtrar a VISUALIZAÇÃO da tabela
          
          // Verificação de integridade dos dados processados (sem afetar gráficos)
          try {
            const temDadosValidos = this.falhas.every(falha => 
              falha && typeof falha === 'object' && falha.id
            );
          } catch (validacaoError) {
            console.error('Erro na validação dos dados de falhas:', validacaoError);
          }
        }
      } catch (error) {
        // Erro ao buscar falhas
      } finally {
        this.loadingFalhas = false
      }
    },
    
    /**
     * ===================================
     * MÉTODOS DE PROCESSAMENTO EM LOTES
     * ===================================
     */
    
    /**
     * Processa um item de falha individual
     */
    processarItemFalha(falha, index) {
      if (!falha || typeof falha !== 'object') {
        console.warn(`🚨 Falha inválida no índice ${index}:`, falha);
        return null;
      }
      
      if (!falha.id) {
        console.warn(`🚨 Falha sem ID no índice ${index}:`, falha);
        return null;
      }
      
            const falhaProcessada = { ...falha }
            
            // Mapear campos do backend para o frontend
            falhaProcessada.hostName = falha.host_name || `Host ${falha.hostid}`
            
            // Calcular dataFormatada para habilitar o botão "Ver Logs"
            if (falha.started_at) {
              try {
                const data = new Date(falha.started_at);
                const dia = String(data.getDate()).padStart(2, '0');
                const mes = String(data.getMonth() + 1).padStart(2, '0');
                const ano = data.getFullYear();
                falhaProcessada.dataFormatada = `${dia}.${mes}.${ano}`;
              } catch (error) {
                console.error('Erro ao formatar data:', error);
                falhaProcessada.dataFormatada = null;
              }
            } else {
              falhaProcessada.dataFormatada = null;
            }
            
            // Garantir que a duração seja um número válido
            if (falha.duracao !== undefined && falha.duracao !== null) {
              falhaProcessada.duracao = Number(falha.duracao);
            } else {
              falhaProcessada.duracao = 0;
            }
            
            // Processar campos de debug se disponíveis
            if (falha.tem_stoped_at !== undefined) {
              falhaProcessada.tem_stoped_at = falha.tem_stoped_at;
            }
            if (falha.tem_started_at !== undefined) {
              falhaProcessada.tem_started_at = falha.tem_started_at;
            }
            if (falha.diferenca_tempo !== undefined) {
              falhaProcessada.diferenca_tempo = falha.diferenca_tempo;
            }
            
            // Adicionar propriedades de vídeo apenas para método CRONOGRAMA
            if (falha.metodo === 'CRONOGRAMA') {
              // Removido: não carregamos mais configuração de vídeo automaticamente
            }
            
            // Adicionar propriedade para análise de IA
            falhaProcessada.analisandoIA = false
            
      return falhaProcessada;
    },
    
    /**
     * Processa falhas diretamente (para volumes pequenos)
     */
    async processarFalhasDireto(falhasArray) {
      const falhasProcessadas = falhasArray.map((falha, index) => {
        return this.processarItemFalha(falha, index);
      }).filter(item => item !== null);
      
      // Atribuir de forma segura
      this.falhas = falhasProcessadas;
      
      // Aguardar próximo tick para garantir reatividade
      await this.$nextTick();
      
      // VALIDAÇÃO FINAL: Verificar integridade após processamento
      this.verificarIntegridadeDados();
    },
    
    /**
     * Processa falhas em lotes (para volumes grandes)
     */
    async processarFalhasEmLotes(falhasArray, tamanhoLote) {
      // Marcar que estamos processando grande volume
      this.processandoGrandeVolume = true;
      
      // Inicializar array vazio
      this.falhas = [];
      await this.$nextTick();
      
      const totalLotes = Math.ceil(falhasArray.length / tamanhoLote);
      
      for (let i = 0; i < totalLotes; i++) {
        const inicio = i * tamanhoLote;
        const fim = Math.min(inicio + tamanhoLote, falhasArray.length);
        const lote = falhasArray.slice(inicio, fim);
        
        // Processar lote atual
        const loteProcessado = lote.map((falha, indexLocal) => {
          const indexGlobal = inicio + indexLocal;
          return this.processarItemFalha(falha, indexGlobal);
        }).filter(item => item !== null);
        
        // Adicionar lote ao array principal
        this.falhas.push(...loteProcessado);
        
        // Aguardar próximo tick entre lotes para não sobrecarregar o Vue
        await this.$nextTick();
        
        // Pequena pausa para permitir que o browser processe outros eventos
        if (i < totalLotes - 1) { // Não pausar no último lote
          await new Promise(resolve => setTimeout(resolve, 10));
        }
      }
      
      // Resetar flag de grande volume após processamento
      this.processandoGrandeVolume = false;
      
      // VALIDAÇÃO FINAL: Verificar integridade após processamento em lotes
      this.verificarIntegridadeDados();
    },
    
    /**
     * Processa um item de atualização individual
     */
    processarItemAtualizacao(atualizacao, index) {
      if (!atualizacao || typeof atualizacao !== 'object') {
        return null;
      }
      
      if (!atualizacao.id) {
        return null;
      }
      
      const atualizacaoProcessada = { ...atualizacao }
      
      // Mapear campos do backend para o frontend
      atualizacaoProcessada.hostName = atualizacao.host_name || `Host ${atualizacao.hostid}`
      
      // Calcular dataFormatada para habilitar o botão "Ver Logs"
      if (atualizacao.started_at) {
        try {
          const data = new Date(atualizacao.started_at);
          const dia = String(data.getDate()).padStart(2, '0');
          const mes = String(data.getMonth() + 1).padStart(2, '0');
          const ano = data.getFullYear();
          atualizacaoProcessada.dataFormatada = `${dia}.${mes}.${ano}`;
      } catch (error) {
          console.error('Erro ao formatar data:', error);
          atualizacaoProcessada.dataFormatada = null;
        }
      } else {
        atualizacaoProcessada.dataFormatada = null;
      }
      
      // Garantir que a duração seja um número válido
      if (atualizacao.duracao !== undefined && atualizacao.duracao !== null) {
        atualizacaoProcessada.duracao = Number(atualizacao.duracao);
      } else {
        atualizacaoProcessada.duracao = 0;
      }
      
      // Processar campos de debug se disponíveis
      if (atualizacao.tem_stoped_at !== undefined) {
        atualizacaoProcessada.tem_stoped_at = atualizacao.tem_stoped_at;
      }
      if (atualizacao.tem_started_at !== undefined) {
        atualizacaoProcessada.tem_started_at = atualizacao.tem_started_at;
      }
      if (atualizacao.diferenca_tempo !== undefined) {
        atualizacaoProcessada.diferenca_tempo = atualizacao.diferenca_tempo;
      }
      
      return atualizacaoProcessada;
    },
    
    /**
     * Processa atualizações diretamente (para volumes pequenos)
     */
    async processarAtualizacoesDireto(atualizacoesArray) {
      const atualizacoesProcessadas = atualizacoesArray.map((atualizacao, index) => {
        return this.processarItemAtualizacao(atualizacao, index);
      }).filter(item => item !== null);
      
      // 1. ✅ Validação de keys para tabela (Vue.js usa ID por padrão)
      const atualizacoesComKeysValidas = atualizacoesProcessadas.filter((item, index) => {
        if (!item.id || typeof item.id !== 'number') {
          return false;
        }
        return true;
      });
      
      // Atribuir de forma segura
      this.atualizacoes = atualizacoesComKeysValidas;
      
      
      // Aguardar próximo tick para garantir reatividade
      await this.$nextTick();
    },
    
    /**
     * Processa atualizações em lotes (para volumes grandes)
     */
    async processarAtualizacoesEmLotes(atualizacoesArray, tamanhoLote) {
      // Marcar que estamos processando grande volume
      this.processandoGrandeVolume = true;
      
      // Inicializar array vazio
      this.atualizacoes = [];
      await this.$nextTick();
      
      const totalLotes = Math.ceil(atualizacoesArray.length / tamanhoLote);
      
      for (let i = 0; i < totalLotes; i++) {
        const inicio = i * tamanhoLote;
        const fim = Math.min(inicio + tamanhoLote, atualizacoesArray.length);
        const lote = atualizacoesArray.slice(inicio, fim);
        
        // Processar lote atual
        const loteProcessado = lote.map((atualizacao, indexLocal) => {
          const indexGlobal = inicio + indexLocal;
          return this.processarItemAtualizacao(atualizacao, indexGlobal);
        }).filter(item => item !== null);
        
        // 1. ✅ Validação de keys antes de adicionar lote
        const loteComKeysValidas = loteProcessado.filter((item, indexLocal) => {
          if (!item.id || typeof item.id !== 'number') {
            console.error(`🚨 VALIDAÇÃO KEY LOTE - Item sem ID válido:`, {
              lote: i + 1,
              item: indexLocal,
              id: item.id,
              tipo: typeof item.id
            });
            return false;
          }
          return true;
        });
        
        // Adicionar lote ao array principal
        this.atualizacoes.push(...loteComKeysValidas);
        
        // Aguardar próximo tick entre lotes para não sobrecarregar o Vue
        await this.$nextTick();
        
        // Pequena pausa para permitir que o browser processe outros eventos
        if (i < totalLotes - 1) { // Não pausar no último lote
          await new Promise(resolve => setTimeout(resolve, 10));
        }
      }
      
      
      // Resetar flag de grande volume após processamento
      this.processandoGrandeVolume = false;
    },
    
    /**
     * ===================================
     * MÉTODOS DE VALIDAÇÃO DE INTEGRIDADE
     * ===================================
     */
    
    /**
     * Verifica a integridade de todos os dados antes da renderização
     */
    verificarIntegridadeDados() {
      const problemas = [];
      
      // 1. ✅ Verificar se arrays principais são válidos
      if (!Array.isArray(this.atualizacoes)) {
        problemas.push('atualizacoes não é array');
      }
      if (!Array.isArray(this.falhas)) {
        problemas.push('falhas não é array');
      }
      
      // 2. ✅ Verificar se computed properties retornam arrays
      try {
        const falhasUnificadas = this.falhasUnificadas;
        if (!Array.isArray(falhasUnificadas)) {
          problemas.push('falhasUnificadas não é array');
        } else {
          // 1. ✅ Verificar se todas as keys existem
          falhasUnificadas.forEach((item, index) => {
            if (!item || !item.idUnificado) {
              problemas.push(`falhasUnificadas[${index}] sem idUnificado`);
            }
          });
        }
      } catch (error) {
        problemas.push(`Erro ao acessar falhasUnificadas: ${error.message}`);
      }
      
      // 3. ✅ Verificar se estatísticas são válidas
      try {
        const estatisticasSistemas = this.estatisticasPorSistemaAjustadas;
        if (!Array.isArray(estatisticasSistemas)) {
          problemas.push('estatisticasPorSistemaAjustadas não é array');
        }
      } catch (error) {
        problemas.push(`Erro ao acessar estatisticasPorSistemaAjustadas: ${error.message}`);
      }
      
      if (problemas.length > 0) {
        console.error('🚨 PROBLEMAS DE INTEGRIDADE DETECTADOS:', problemas);
        return false;
      }
      
      return true;
    },
    
    async abrirDialogConfigVideo(item) {
      // Verificar se o método permite configuração de vídeo
      // Apenas CRONOGRAMA e CRONOGRAMA_RETRY permitem configuração de vídeo
      if (item.metodo !== 'CRONOGRAMA' && item.metodo !== 'CRONOGRAMA_RETRY') {
        return; // Não fazer nada se não for CRONOGRAMA ou CRONOGRAMA_RETRY
      }
      
      // Abrir dialog e buscar configuração de vídeo do host
      this.dialogVideoItem = item;
      this.dialogVideoHostId = item.hostid;
      this.dialogVideoHostName = item.hostName;
      this.dialogVideoLoading = true;
      this.dialogVideo = true;
      
      try {
        // Buscar cronograma do host para obter configuração de vídeo
        // O endpoint já aceita Zabbix ID diretamente, não precisa converter
        const response = await hostsService.getCronogramaByHostId(item.hostid);
        
        // Definir valor inicial do switch
        if (response && response.logsVideo !== undefined) {
          this.dialogVideoValue = response.logsVideo;
        } else {
          // Padrão para hosts sem cronograma
          this.dialogVideoValue = false;
        }
      } catch (error) {
        // Se for 404, significa que não existe cronograma - usar valor padrão
        if (error.response?.status === 404) {
          this.dialogVideoValue = false;
        } else {
          console.warn(`Erro ao buscar configuração de vídeo para host ${item.hostid}:`, error);
          this.dialogVideoValue = false;
          this.mostrarNotificacao('Erro ao carregar configuração de vídeo', 'error');
        }
      } finally {
        this.dialogVideoLoading = false;
      }
    },
    
    async salvarConfigVideo() {
      this.dialogVideoSaving = true;
      try {
        // O endpoint updateVideoLogs aceita Zabbix ID diretamente
        const response = await dashboardService.updateVideoLogs(this.dialogVideoHostId, this.dialogVideoValue);
        
        if (response.success) {
          this.mostrarNotificacao(
            this.dialogVideoValue ? 'Gravação de vídeo ativada' : 'Gravação de vídeo desativada', 
            'success'
          );
          this.dialogVideo = false;
        } else {
          throw new Error(response.message || 'Erro ao atualizar configuração');
        }
      } catch (error) {
        this.mostrarNotificacao(
          error.message || 'Erro ao atualizar configuração de vídeo', 
          'error'
        );
      } finally {
        this.dialogVideoSaving = false;
      }
    },
    
    /**
     * ===================================
     * MÉTODOS DE CONTROLE ROBUSTO DE GRÁFICOS
     * ===================================
     */
    
    /**
     * Verifica se a estrutura dos dados mudou para decidir se deve recriar ou atualizar
     */
    verificarMudancaEstrutura(tipo, dados) {
      if (!dados || !Array.isArray(dados)) {
        return { mudou: true, estrutura: null };
      }
      
      // Extrair estrutura (campos únicos dos dados)
      // 6. ✅ Object.keys(x) só quando x é garantido (ou x || {})
      const estrutura = dados.length > 0 ? Object.keys(dados[0] || {}).sort().join('|') : 'empty';
      const controle = this.graficosEstrutura[tipo];
      const ultimaEstrutura = controle ? controle.ultimaEstrutura : null;
      
      // Se é a primeira vez ou estrutura mudou
      const mudou = ultimaEstrutura === null || ultimaEstrutura !== estrutura;
      
      
      return { mudou, estrutura };
    },
    
    /**
     * Determina se deve criar ou atualizar um gráfico
     */
    deveRecriarGrafico(tipo, dados) {
      const controle = this.graficosEstrutura[tipo];
      if (!controle) return { deveRecriar: true, estrutura: null };
      
      const { mudou, estrutura } = this.verificarMudancaEstrutura(tipo, dados);
      
      // Se nunca foi criado ou estrutura mudou
      const deveRecriar = !controle.criado || mudou;
      
      
      return { deveRecriar, estrutura };
    },
    
    /**
     * Marca um gráfico como criado e salva sua estrutura
     */
    marcarGraficoCriado(tipo, estrutura, dados) {
      if (!this.graficosEstrutura[tipo]) {
        this.graficosEstrutura[tipo] = {};
      }
      
      this.graficosEstrutura[tipo] = {
        criado: true,
        ultimaEstrutura: estrutura,
        ultimosDados: dados ? [...dados] : [] // Clone dos dados
      };
      
    },
    
    /**
     * Reseta controle de um gráfico específico
     */
    resetarControleGrafico(tipo) {
      if (this.graficosEstrutura[tipo]) {
        this.graficosEstrutura[tipo].criado = false;
        this.graficosEstrutura[tipo].ultimaEstrutura = null;
        this.graficosEstrutura[tipo].ultimosDados = null;
      }
    },
    
    criarGraficos() {
      // Aguardar um pouco para garantir que o DOM está pronto
      setTimeout(() => {
        this.criarGraficoSistemas()
        this.criarGraficoSistemasPorHost()
        this.criarGraficoMetodos()
        this.criarGraficoMetodosPorHost()
        this.criarGraficoAtualizacoesPorcentagem()
        this.criarGraficoClientesPorcentagem()
      }, 100)
    },
    
    criarGraficoSistemas() {
      if (!Chart) {
        return
      }
      
      const ctx = document.getElementById('chartSistemas')
      if (!ctx) {
        return
      }
      
      // Usar as estatísticas ajustadas que consideram falhas ocultadas
      const dados = this.estatisticasPorSistemaAjustadas;
      
      
      if (!dados || !Array.isArray(dados) || dados.length === 0) {
        // Criar gráfico vazio
        if (this.chartSistemas) {
          this.chartSistemas.destroy()
        }
        
        try {
          this.chartSistemas = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: ['Sem dados'],
              datasets: [{
                label: 'Sem dados disponíveis',
                data: [0],
                backgroundColor: '#E0E0E0'
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false
                }
              }
            }
          })
        } catch (error) {
          // Erro ao criar gráfico vazio de sistemas
        }
        return
      }
      
      if (this.chartSistemas) {
        this.chartSistemas.destroy()
      }
      
      // Ordenar dados seguindo a sequência padrão VPRA | VSUC | VSUP
      const dadosOrdenados = this.ordenarDadosPorSistema(dados, 'sistema');
      
      try {
        this.chartSistemas = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: dadosOrdenados.map(item => item.sistema),
            datasets: [
              {
                label: 'Sucessos',
                data: dadosOrdenados.map(item => item.sucessos),
                backgroundColor: '#4CAF50',
                borderColor: '#4CAF50',
                borderWidth: 1
              },
              {
                label: 'Falhas',
                data: dadosOrdenados.map(item => item.falhas),
                backgroundColor: '#F44336',
                borderColor: '#F44336',
                borderWidth: 1
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: {
                stacked: true
              },
              y: {
                stacked: true,
                beginAtZero: true
              }
            },
            plugins: {
              legend: {
                position: 'top'
              },
              tooltip: {
                mode: 'index',
                intersect: false
              }
            }
          }
        })
      } catch (error) {
        // Erro ao criar gráfico de sistemas
      }
    },

    criarGraficoSistemasPorHost() {
      if (!Chart) {
        return
      }
      
      const ctx = document.getElementById('chartSistemasPorHost')
      if (!ctx) {
        return
      }
      
      // Usar as estatísticas por sistema por host
      const dados = this.estatisticas.estatisticasPorSistemaPorHost || [];
      
      
      if (!dados || !Array.isArray(dados) || dados.length === 0) {
        console.warn('🚨 Dados de sistemas por host vazios, criando gráfico vazio');
        
        // Destruir gráfico anterior se existir
        if (this.chartSistemasPorHost) {
          this.chartSistemasPorHost.destroy()
          this.chartSistemasPorHost = null;
        }
        
        try {
          this.chartSistemasPorHost = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: ['Sem dados'],
              datasets: [{
                label: 'Sem dados disponíveis',
                data: [0],
                backgroundColor: '#E0E0E0'
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false
                },
                title: {
                  display: true,
                  text: 'Por Cliente - Sem dados'
                }
              }
            }
          });
          
        } catch (error) {
          console.error('🚨 Erro ao criar gráfico vazio de sistemas por host:', error);
        }
        return
      }
      
      if (this.chartSistemasPorHost) {
        this.chartSistemasPorHost.destroy()
      }
      
      // Ordenar dados seguindo a sequência padrão VPRA | VSUC | VSUP
      const dadosOrdenados = this.ordenarDadosPorSistema(dados, 'sistema');
      
      try {
        
        // Validar dados antes de criar o gráfico - aceitar strings que podem ser convertidas
        const dadosValidados = dadosOrdenados.filter(item => {
          if (!item || !item.sistema) {
            console.warn('🚨 Item sem sistema:', item);
            return false;
          }
          
          // Aceitar tanto números quanto strings que representam números
          const temHostsSucesso = item.hosts_sucesso !== undefined && item.hosts_sucesso !== null;
          const temHostsFalha = item.hosts_falha !== undefined && item.hosts_falha !== null;
          
          const valido = temHostsSucesso && temHostsFalha;
          
          if (!valido) {
            console.warn('🚨 Item sem dados válidos de hosts:', {
              item,
              temHostsSucesso,
              temHostsFalha,
              hosts_sucesso: item.hosts_sucesso,
              hosts_falha: item.hosts_falha
            });
          }
          
          return valido;
        });
        
        if (dadosValidados.length === 0) {
          console.warn('🚨 Nenhum dado válido encontrado após validação');
          return;
        }
        
        
        this.chartSistemasPorHost = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: dadosValidados.map(item => item.sistema),
            datasets: [
              {
                label: 'Clientes com Sucesso',
                data: dadosValidados.map(item => parseInt(item.hosts_sucesso) || 0),
                backgroundColor: '#4CAF50', // Verde (igual ao "Por Registro")
                borderColor: '#4CAF50',
                borderWidth: 1
              },
              {
                label: 'Clientes com Falha',
                data: dadosValidados.map(item => parseInt(item.hosts_falha) || 0),
                backgroundColor: '#F44336', // Vermelho (igual ao "Por Registro")
                borderColor: '#F44336',
                borderWidth: 1
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: {
                stacked: true
              },
              y: {
                stacked: true,
                beginAtZero: true
              }
            },
            plugins: {
              legend: {
                position: 'top'
              },
              tooltip: {
                mode: 'index',
                intersect: false
              }
            }
          }
        });
        
        
      } catch (error) {
        console.error('🚨 Erro ao criar gráfico de sistemas por host:', error);
        console.error('Stack trace:', error.stack);
        this.chartSistemasPorHost = null;
      }
    },

    criarGraficoMetodosPorHost() {
      if (!Chart) {
        return
      }
      
      const ctx = document.getElementById('chartMetodosPorHost')
      if (!ctx) {
        return
      }
      
      // Usar as estatísticas por método por host
      let dados = this.estatisticas.estatisticasPorMetodoPorHost || [];
      
      // Ordenar dados em ordem decrescente (do maior para o menor valor)
      if (dados && Array.isArray(dados) && dados.length > 0) {
        dados = [...dados].sort((a, b) => (b.total_hosts || 0) - (a.total_hosts || 0));
      }
      
      if (!dados || !Array.isArray(dados) || dados.length === 0) {
        // Criar gráfico vazio
        if (this.chartMetodosPorHost) {
          this.chartMetodosPorHost.destroy()
        }
        
        try {
          this.chartMetodosPorHost = new Chart(ctx, {
            type: 'pie', // Mudando para pie chart como o "Por Registro"
            data: {
              labels: ['Sem dados'],
              datasets: [{
                data: [1],
                backgroundColor: ['#E0E0E0']
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false
                }
              }
            }
          })
        } catch (error) {
          // Erro ao criar gráfico vazio de métodos por host
        }
        return
      }
      
      if (this.chartMetodosPorHost) {
        this.chartMetodosPorHost.destroy()
      }
      
              // Cores específicas para cada método (correspondem às cores dos chips no histórico)
        const coresPorMetodo = {
          'CRONOGRAMA': this.getCorMetodoHex('CRONOGRAMA'),        // deep-purple (roxo escuro)
          'CRONOGRAMA_RETRY': this.getCorMetodoHex('CRONOGRAMA_RETRY'),  // #03dac6 (ciano/turquesa fixo)
          'MANUAL': this.getCorMetodoHex('MANUAL'),             // primary (azul)
          'MANUAL_CRONOGRAMA': this.getCorMetodoHex('MANUAL_CRONOGRAMA') // grey (cinza)
        }
        
        try {
          this.chartMetodosPorHost = new Chart(ctx, {
            type: 'pie', // Mudando para pie chart como o "Por Registro"
            data: {
              labels: dados.map(item => item.metodo),
              datasets: [{
                data: dados.map(item => item.total_hosts),
                backgroundColor: dados.map(item => coresPorMetodo[item.metodo] || '#E0E0E0'),
                borderWidth: 2,
                borderColor: '#fff'
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  position: 'right',
                  labels: {
                    boxWidth: 12,
                    boxHeight: 12,
                    usePointStyle: true,
                    padding: 10,
                    font: {
                      size: 10
                    }
                  }
                },
                tooltip: {
                  callbacks: {
                    label: function(context) {
                      const label = context.label || '';
                      const value = context.parsed;
                      const total = context.dataset.data.reduce((a, b) => a + b, 0);
                      const percentage = ((value / total) * 100).toFixed(1);
                      return `${label}: ${value} clientes (${percentage}%)`;
                    }
                  }
                }
              }
            }
          })
        } catch (error) {
          // Erro ao criar gráfico de métodos por host
        }
    },
    
    criarGraficoMetodos() {
      if (!Chart) {
        return
      }
      
      const ctx = document.getElementById('chartMetodos')
      if (!ctx) {
        return
      }
      
      // Usar as estatísticas ajustadas que consideram falhas ocultadas
      let dados = this.estatisticasPorMetodoAjustadas;
      
      // Ordenar dados em ordem decrescente (do maior para o menor valor)
      if (dados && Array.isArray(dados) && dados.length > 0) {
        dados = [...dados].sort((a, b) => (b.total || 0) - (a.total || 0));
      }
      
      if (!dados || !Array.isArray(dados) || dados.length === 0) {
        // Criar gráfico vazio
        if (this.chartMetodos) {
          this.chartMetodos.destroy()
        }
        
        try {
          this.chartMetodos = new Chart(ctx, {
            type: 'pie',
            data: {
              labels: ['Sem dados'],
              datasets: [{
                data: [1],
                backgroundColor: ['#E0E0E0']
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false
                }
              }
            }
          })
        } catch (error) {
          // Erro ao criar gráfico vazio de métodos
        }
        return
      }
      
      if (this.chartMetodos) {
        this.chartMetodos.destroy()
      }
      
      // Cores específicas para cada método (correspondem às cores dos chips no histórico)
      const coresPorMetodo = {
        'CRONOGRAMA': this.getCorMetodoHex('CRONOGRAMA'),        // deep-purple (roxo escuro)
        'CRONOGRAMA_RETRY': this.getCorMetodoHex('CRONOGRAMA_RETRY'),  // #03dac6 (ciano/turquesa fixo)
        'MANUAL': this.getCorMetodoHex('MANUAL'),             // primary (azul)
        'MANUAL_CRONOGRAMA': this.getCorMetodoHex('MANUAL_CRONOGRAMA') // grey (cinza)
      }
      
      try {
        this.chartMetodos = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: dados.map(item => item.metodo),
            datasets: [{
              data: dados.map(item => item.total),
              backgroundColor: dados.map(item => coresPorMetodo[item.metodo] || '#E0E0E0'),
              borderWidth: 2,
              borderColor: '#fff'
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: 'right',
                labels: {
                  boxWidth: 12,
                  boxHeight: 12,
                  usePointStyle: true,
                  padding: 10,
                  font: {
                    size: 10
                  }
                }
              },
              tooltip: {
                callbacks: {
                  label: function(context) {
                    const label = context.label || '';
                    const value = context.parsed || 0;
                    const total = context.dataset.data.reduce((a, b) => a + b, 0);
                    const percentage = ((value / total) * 100).toFixed(1);
                    return `${label}: ${value} registros (${percentage}%)`;
                  }
                }
              }
            }
          }
        })
      } catch (error) {
        // Erro ao criar gráfico de métodos
      }
    },

    criarGraficoAtualizacoesPorcentagem() {
      if (!Chart) {
        return
      }

      const ctx = document.getElementById('chartAtualizacoesPorcentagem')
      if (!ctx) {
        return
      }

      // Usar as estatísticas ajustadas que consideram falhas ocultadas
      const estatisticas = this.estatisticasAjustadas
      const totalSucessos = estatisticas.totalSucessos || 0
      const totalFalhas = estatisticas.totalFalhas || 0
      const totalAtualizacoes = estatisticas.totalAtualizacoes || 0

      if (totalAtualizacoes === 0) {
        // Criar gráfico vazio
        if (this.chartAtualizacoesPorcentagem) {
          this.chartAtualizacoesPorcentagem.destroy()
        }

        try {
          this.chartAtualizacoesPorcentagem = new Chart(ctx, {
            type: 'doughnut',
            data: {
              labels: ['Sem dados'],
              datasets: [{
                data: [1],
                backgroundColor: ['#E0E0E0']
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false
                }
              }
            }
          })
        } catch (error) {
          // Erro ao criar gráfico vazio de porcentagem
        }
        return
      }

      if (this.chartAtualizacoesPorcentagem) {
        this.chartAtualizacoesPorcentagem.destroy()
      }

      const cores = ['#4CAF50', '#F44336'] // Verde para sucesso, Vermelho para falha

      try {
        this.chartAtualizacoesPorcentagem = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: ['Sucessos', 'Falhas'],
            datasets: [{
              data: [totalSucessos, totalFalhas],
              backgroundColor: cores,
              borderWidth: 2,
              borderColor: '#fff'
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false  // Remover legenda para economizar espaço
              },
              tooltip: {
                enabled: true,
                mode: 'point',
                intersect: false,
                animation: {
                  duration: 0
                },
                displayColors: true,
                callbacks: {
                  title: function() {
                    return 'Atualizações'
                  },
                  label: function(context) {
                    const label = context.label || ''
                    const value = context.parsed || 0
                    const dataset = context.dataset
                    const total = dataset.data.reduce((a, b) => a + b, 0)
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0
                    return `${label}: ${value} (${percentage}%)`
                  }
                }
              }
            }
          }
        })
      } catch (error) {
        // Erro ao criar gráfico de porcentagem
      }
    },

    criarGraficoClientesPorcentagem() {
      if (!Chart) {
        return
      }
      
      const ctx = document.getElementById('chartClientesPorcentagem')
      if (!ctx) {
        return
      }
      
      // Calcular porcentagens baseadas nas estatísticas por host/hostid
      const totalHosts = this.estatisticas.totalHostsUnicos || 0
      const hostsSucesso = this.estatisticas.hostsComSucesso || 0
      const hostsFalha = this.estatisticas.hostsComFalha || 0
      
      if (totalHosts === 0) {
        // Criar gráfico vazio
        if (this.chartClientesPorcentagem) {
          this.chartClientesPorcentagem.destroy()
        }
        
        try {
          this.chartClientesPorcentagem = new Chart(ctx, {
            type: 'doughnut',
            data: {
              labels: ['Sem dados'],
              datasets: [{
                data: [1],
                backgroundColor: ['#E0E0E0']
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false
                }
              }
            }
          })
        } catch (error) {
          // Erro ao criar gráfico vazio de porcentagem de clientes
        }
        return
      }
      
      if (this.chartClientesPorcentagem) {
        this.chartClientesPorcentagem.destroy()
      }
      
      const cores = ['#4CAF50', '#F44336'] // Verde para sucesso, Vermelho para falha
      
      try {
        this.chartClientesPorcentagem = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: ['Clientes com Sucesso', 'Clientes com Falha'],
            datasets: [{
              data: [hostsSucesso, hostsFalha],
              backgroundColor: cores,
              borderWidth: 2,
              borderColor: '#fff'
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false  // Remover legenda para economizar espaço
              },
              tooltip: {
                enabled: true,
                mode: 'point',
                intersect: false,
                animation: {
                  duration: 0
                },
                displayColors: true,
                callbacks: {
                  title: function() {
                    return 'Clientes'
                  },
                  label: function(context) {
                    const label = context.label || ''
                    const value = context.parsed || 0
                    const dataset = context.dataset
                    const total = dataset.data.reduce((a, b) => a + b, 0)
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0
                    return `${label}: ${value} (${percentage}%)`
                  }
                }
              }
            }
          }
        })
      } catch (error) {
        // Erro ao criar gráfico de porcentagem de clientes
      }
    },
    
    destruirGraficos() {
      if (this.chartSistemas) {
        this.chartSistemas.destroy()
      }
      if (this.chartSistemasPorHost) {
        this.chartSistemasPorHost.destroy()
      }
      if (this.chartMetodos) {
        this.chartMetodos.destroy()
      }
      if (this.chartMetodosPorHost) {
        this.chartMetodosPorHost.destroy()
      }
      if (this.chartAtualizacoesPorcentagem) {
        this.chartAtualizacoesPorcentagem.destroy()
      }
      if (this.chartClientesPorcentagem) {
        this.chartClientesPorcentagem.destroy()
      }
    },
    
    aplicarFiltros() {
      // Processar filtros usando a função centralizada
      const filtrosProcessados = this.processarFiltros()
      
      // Resetar página para 1 quando aplicar filtros (apenas histórico de atualizações)
      this.optionsTabela.page = 1
      
      // Resetar cache de RETRYs bem-sucedidos
      this.retryDataLoaded = false;
      this.retryBemSucedidoCache.clear();
      
      // Limpar o cache de dias com atualizações
      this.limparCacheDiasComAtualizacao();
      
      try {
        // Detectar se pode ser um grande volume baseado no período de datas
        const filtrosProcessados = this.processarFiltros();
        const dataInicio = new Date(filtrosProcessados.dataInicio);
        const dataFim = new Date(filtrosProcessados.dataFim);
        const diasPeriodo = Math.ceil((dataFim - dataInicio) / (1000 * 60 * 60 * 24));
        
        // Considerar grande volume se período > 30 dias ou se há filtros de base_size
        this.processandoGrandeVolume = diasPeriodo > 30 || 
          (filtrosProcessados.baseSizeMin !== null || filtrosProcessados.baseSizeMax !== null);
        
      
      // Resetar flag de dados principais carregados
      this.dadosPrincipaisCarregados = false;
      
      // Resetar flag de gráficos inicializados para forçar recriação
      this.graficosInicializados = false;
        
        // Resetar controle de gráficos para forçar verificação completa
        Object.keys(this.graficosEstrutura).forEach(tipo => {
          this.resetarControleGrafico(tipo);
        });
        
      
      // Recarregar range de base_size com as novas datas (se houver)
      if (filtrosProcessados.dataInicio && filtrosProcessados.dataFim) {
        this.buscarBaseSizeRange()
      }
      
      // Aplicar filtros usando os processados
      this.buscarEstatisticas(filtrosProcessados)
      this.buscarAtualizacoes(filtrosProcessados)
      this.buscarFalhas(filtrosProcessados)
        
        
      } catch (error) {
        console.error('🚨 Erro crítico ao aplicar filtros:', error);
        console.error('Stack:', error.stack);
        
        // Tentar recuperar resetando tudo
        this.graficosInicializados = false;
        this.dadosPrincipaisCarregados = false;
        this.destruirGraficos();
        
        // Mostrar erro ao usuário se disponível
        if (this.$toast) {
          this.$toast.error('Erro ao aplicar filtros. Tente novamente.');
        }
      }
      
      console.groupEnd();
      
      // NÃO recriar gráficos aqui - eles serão criados pelo buscarEstatisticas
    },
    
    limparFiltros() {
      const dataAtual = this.obterDataAtual()
      this.filtros = {
        dataInicio: dataAtual,
        dataFim: dataAtual,
        horaInicio: null,
        horaFim: null,
        sistemas: [], // Array vazio para o novo campo de múltiplos sistemas
        metodos: [], // Array vazio para o novo campo de múltiplos métodos
        hostids: [], // Array vazio para o novo campo de múltiplos hosts
        atualizado: null,
        finalizado: true, // Por padrão, mostrar apenas registros finalizados
        baseSizeMin: null, // Limpar filtro de base mínima
        baseSizeMax: null  // Limpar filtro de base máxima
      }
      this.searchHistorico = '' // Limpar pesquisa
      this.searchFalhas = '' // Limpar pesquisa das falhas
      this.ignorarFalhasComRetry = true // Resetar para o padrão (ativado)
      
      // Resetar slider de base_size para o range completo
      this.baseSizeSliderValue = [this.baseSizeRange.min, this.baseSizeRange.max]
      
      // Resetar cache de RETRYs bem-sucedidos
      this.retryDataLoaded = false;
      this.retryBemSucedidoCache.clear();
      
      // Limpar o cache de dias com atualizações
      this.limparCacheDiasComAtualizacao();
      
      // Resetar flag de dados principais carregados
      this.dadosPrincipaisCarregados = false;
      
      // Resetar flag de gráficos inicializados para forçar recriação
      this.graficosInicializados = false;
      
      this.buscarDados()
      
      // NÃO recriar gráficos aqui - eles serão criados pelo buscarEstatisticas
    },
    
    pesquisarHistorico() {
      // Debounce para evitar muitas chamadas
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      
      this.searchTimeout = setTimeout(() => {
        // Resetar página para 1 quando pesquisar
        this.optionsTabela.page = 1
        this.buscarAtualizacoes()
        
        // REMOVIDO: Pesquisa afeta apenas a TABELA, não os gráficos
        // Os gráficos usam dados de ESTATÍSTICAS, não dados filtrados da TABELA
        // if (this.graficosInicializados && this.dadosPrincipaisCarregados) {
        //   this.atualizarGraficosSeNecessario();
        // }
      }, 500)
    },

    pesquisarFalhas() {
      // Debounce para evitar muitas chamadas
      if (this.searchFalhasTimeout) {
        clearTimeout(this.searchFalhasTimeout)
      }
      
      this.searchFalhasTimeout = setTimeout(() => {
        // Buscar falhas (sem paginação)
        this.buscarFalhas()
      }, 500)
    },
    
    atualizarDados() {
      this.buscarDados()
      
      // NÃO recriar gráficos aqui - eles serão criados/atualizados pelos métodos de busca
    },
    
    /**
     * Método chamado quando o switch de ignorar falhas com retry é alterado
     */
    async alternarIgnorarFalhas() {
      
      if (this.ignorarFalhasComRetry) {
        // Se ativou o modo de ignorar falhas, recarregar o cache de RETRYs
        this.retryDataLoaded = false;
        this.retryBemSucedidoCache.clear();
        await this.carregarRetryBemSucedidos();
      }
      
      // Apenas atualizar os gráficos se já estiverem inicializados
      if (this.graficosInicializados) {
        this.atualizarGraficosSeNecessario();
      }
      
      // Forçar atualização da interface
      this.$forceUpdate();
    },
    
    acessarLogs(item) {
      // Gerar data formatada no formato DD.MM.YYYY esperado pelo DashboardLogViewer
      let dataFormatada = null;
      if (item.started_at) {
        try {
          const data = new Date(item.started_at);
          const dia = String(data.getDate()).padStart(2, '0');
          const mes = String(data.getMonth() + 1).padStart(2, '0');
          const ano = data.getFullYear();
          dataFormatada = `${dia}.${mes}.${ano}`;
        } catch (error) {
          console.error('Erro ao formatar data:', error);
        }
      }
      
      if (!dataFormatada) {
        this.mostrarNotificacao('Data não disponível para acessar logs', 'warning')
        return
      }
      
      // Configurar dados para o log viewer
      this.selectedLogItem = {
        hostId: item.hostid.toString(), // Converter para string para compatibilidade
        hostName: item.hostName,
        sistema: item.sistema,
        dataFormatada: dataFormatada,
        atualizacaoId: item.id // Adicionar o ID da atualização
      }
      
      // Se este item tem um retry associado, vamos registrar isso no console para debug
      if (item.retry) {
      }
      
      // Abrir o log viewer
      this.logViewerDialog = true
      
      // Atualizar a URL do navegador para incluir o ID da atualização
      this.atualizarURLComLogview(item.id, item.hostid, item.sistema, dataFormatada);
    },
    
    /**
     * Atualiza a URL do navegador para incluir o ID da atualização e filtros
     * @param {number} atualizacaoId - ID da atualização
     * @param {string|number} hostid - ID do host
     * @param {string} sistema - Nome do sistema
     * @param {string} dataFormatada - Data formatada no formato DD.MM.YYYY
     */
    atualizarURLComLogview(atualizacaoId, hostid, sistema, dataFormatada) {
      try {
        // Converter data formatada (DD.MM.YYYY) para YYYY-MM-DD para os filtros
        let dataFiltro = null;
        if (dataFormatada) {
          const partes = dataFormatada.split('.');
          if (partes.length === 3) {
            dataFiltro = `${partes[2]}-${partes[1]}-${partes[0]}`;
          }
        }
        
        // Criar objeto de filtros que será enviado como parte da URL
        const filtros = {
          dataInicio: dataFiltro,
          dataFim: dataFiltro,
          hostid: hostid,
          sistema: sistema
        };
        
        // Serializar filtros para URL
        const filtrosSerializados = encodeURIComponent(JSON.stringify(filtros));
        
        // Construir a URL completa com o hash, o parâmetro logview e os filtros
        const baseUrl = window.location.origin + window.location.pathname;
        const newUrl = `${baseUrl}#/dashboard?logview=${atualizacaoId}&filtros=${filtrosSerializados}`;
        
        // Atualizar a URL do navegador sem recarregar a página
        if (history.pushState) {
          history.pushState({ path: newUrl }, '', newUrl);
        }
      } catch (error) {
        console.error('Erro ao atualizar URL com logview:', error);
      }
    },
    
    formatarDuracao(segundos) {
      return dashboardService.formatarDuracao(segundos)
    },
    
    formatarData(dataString) {
      return dashboardService.formatarData(dataString)
    },
    
    formatarTamanhoBase(tamanho) {
      if (!tamanho) return '-';
      return `${tamanho}GB`;
    },
    
    /**
     * Formata valores de base_size para exibição (1 casa decimal se necessário)
     */
    formatBaseSizeDisplay(valor) {
      if (valor === null || valor === undefined) return '0';
      const num = parseFloat(valor);
      // Se é um número inteiro, mostrar sem decimais; senão, mostrar 1 casa decimal
      return num % 1 === 0 ? num.toString() : num.toFixed(1);
    },
    
    /**
     * Extrai apenas a data (sem a hora) de uma string de data ISO
     * @param {string} dataString - String de data no formato ISO ou similar
     * @returns {string} Data no formato YYYY-MM-DD
     */
    extrairDataSemHora(dataString) {
      if (!dataString || typeof dataString !== 'string') {
        console.warn('🚨 extrairDataSemHora - dataString inválida:', dataString);
        return `fallback_${Date.now()}`;
      }
      
      // Extrair a parte da data (YYYY-MM-DD)
      try {
        const data = new Date(dataString);
        if (isNaN(data.getTime())) {
          console.warn('🚨 Data inválida:', dataString);
          return `invalid_${Date.now()}`;
        }
        
        const ano = data.getFullYear();
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const dia = String(data.getDate()).padStart(2, '0');
        return `${ano}-${mes}-${dia}`;
      } catch (error) {
        console.error('Erro ao extrair data:', error);
        return `error_${Date.now()}`;
      }
    },
    
    getCorSistema(sistema) {
      const cores = {
        'VPRA': 'blue',
        'VSUC': 'green',
        'VSUP': 'orange',
        'VCON': '#82B982',
        'VSYN': '#B2C58A'
      }
      return cores[sistema] || 'grey'
    },
    
    getCorMetodo(metodo) {
      // Cores diferentes para melhor visibilidade em ambos os temas
      // Para CRONOGRAMA_RETRY, retornar undefined para usar style customizado
      if (metodo === 'CRONOGRAMA_RETRY') {
        return undefined; // Será tratado com style customizado
      }
      const cores = {
        'MANUAL': 'primary',
        'MANUAL_CRONOGRAMA': 'grey', // Cinza para MANUAL_CRONOGRAMA
        'CRONOGRAMA': this.$vuetify.theme.dark ? 'deep-purple' : 'secondary',
        'AUTOMÁTICO': 'info'
      }
      return cores[metodo] || 'grey'
    },
    
    // Método auxiliar para obter cor hex do método (para gráficos Chart.js)
    getCorMetodoHex(metodo) {
      const isDark = this.$vuetify.theme.dark;
      
      // Cores hex que correspondem às cores dos chips do Vuetify
      const cores = {
        'MANUAL': isDark ? '#1976D2' : '#1976D2', // primary (azul)
        'MANUAL_CRONOGRAMA': isDark ? '#757575' : '#9E9E9E', // grey (cinza)
        'CRONOGRAMA': isDark ? '#7B1FA2' : '#9C27B0', // deep-purple (roxo escuro)
        'CRONOGRAMA_RETRY': '#03dac6', // Cor fixa ciano/turquesa para CRONOGRAMA_RETRY (independente do tema)
        'AUTOMÁTICO': isDark ? '#0288D1' : '#03A9F4' // info (azul claro)
      }
      return cores[metodo] || (isDark ? '#757575' : '#9E9E9E') // grey como padrão
    },
    
    // Método auxiliar para obter estilo customizado para chips com cores hex
    getChipStyle(metodo) {
      if (metodo === 'CRONOGRAMA_RETRY') {
        // Para chips outlined, definir a cor da borda e do texto (cor fixa #03dac6)
        return {
          borderColor: '#03dac6',
          color: '#03dac6'
        }
      }
      return {}
    },

    getIconeSistema(sistema) {
      switch (sistema) {
        case 'VPRA':
          return '/ico_vpra.png'
        case 'VSUC':
          return '/ico_vsuc.png'
        case 'VSUP':
          return '/ico_vsup.png'
        case 'VCON':
          return '/ico_vcon.png'
        case 'VSYN':
          return '/ico_vsyn.png'
        default:
          return '/ico_vpra.png' // ícone padrão
      }
    },
    
    /**
     * Função personalizada para filtrar hosts no autocomplete
     * @param {Object} item - O item do host a ser verificado
     * @param {string} queryText - O texto digitado pelo usuário
     * @param {Object} itemText - O texto do item (não usado diretamente)
     * @returns {boolean} - True se o item deve ser exibido
     */
    filtrarHosts(item, queryText) {
      if (!queryText || queryText.trim() === '') {
        return true;
      }
      
      const query = queryText.toLowerCase().trim();
      
      // Verificar se o nome do host contém o texto digitado
      if (item.name && item.name.toLowerCase().includes(query)) {
        return true;
      }
      
      // Verificar se o ID do host contém o texto digitado
      if (item.hostId && item.hostId.toString().includes(query)) {
        return true;
      }
      
      return false;
    },
    
    /**
     * Função para tratar a seleção de múltiplos hosts no autocomplete
     * @param {Array|null} selectedHosts - Array de hosts selecionados ou null se foi limpo
     */
    selecionarHosts(selectedHosts) {
      if (selectedHosts && Array.isArray(selectedHosts)) {
        // Se há hosts selecionados, manter o array
        this.filtros.hostids = selectedHosts;
      } else {
        // Se foi limpo, definir como array vazio
        this.filtros.hostids = [];
      }
    },
    
    mostrarNotificacao(texto, cor = 'info') {
      this.snackbar = {
        show: true,
        text: texto,
        color: cor
      }
    },

    processarFiltros() {
      const filtrosProcessados = { ...this.filtros }
      
      // Processar filtros de data com horário
      if (filtrosProcessados.dataInicio) {
        const horaInicio = filtrosProcessados.horaInicio || '00:00'
        filtrosProcessados.dataInicio = `${filtrosProcessados.dataInicio}T${horaInicio}:00`
      }
      
      if (filtrosProcessados.dataFim) {
        const horaFim = filtrosProcessados.horaFim || '23:59'
        filtrosProcessados.dataFim = `${filtrosProcessados.dataFim}T${horaFim}:59`
      }
      
      // Processar filtro de status (atualizado)
      if (filtrosProcessados.atualizado === null) {
        // "Todos" ou nenhum filtro selecionado - deve trazer sucessos + falhas
        delete filtrosProcessados.atualizado; // Remove o parâmetro para o backend interpretar como "todos"
      } else if (filtrosProcessados.atualizado === true) {
        // "Sucessos" - apenas registros com atualizado = true
      } else if (filtrosProcessados.atualizado === false) {
        // "Falhas" - apenas registros com atualizado = false
      } else {
        // Valor inesperado - remover e usar comportamento padrão
        console.warn('[DEBUG] processarFiltros - Valor inesperado para atualizado:', filtrosProcessados.atualizado);
        delete filtrosProcessados.atualizado;
      }
      
      // Processar filtro de finalizado
      // Por padrão, finalizado = true (apenas registros finalizados)
      // Se for null ou undefined, usar true como padrão
      if (filtrosProcessados.finalizado === null || filtrosProcessados.finalizado === undefined) {
        filtrosProcessados.finalizado = true;
      }
      
      // Processar filtros de sistemas
      if (filtrosProcessados.sistemas && Array.isArray(filtrosProcessados.sistemas) && filtrosProcessados.sistemas.length > 0) {
        // Se há apenas um sistema selecionado, usamos o campo sistema original para compatibilidade
        if (filtrosProcessados.sistemas.length === 1) {
          filtrosProcessados.sistema = filtrosProcessados.sistemas[0];
        } else {
          // Se há múltiplos sistemas, enviamos como um array JSON stringificado
          filtrosProcessados.sistema = JSON.stringify(filtrosProcessados.sistemas);
        }
      } else {
        // Se não há sistemas selecionados, enviamos null
        filtrosProcessados.sistema = null;
      }
      
      // Processar filtros de métodos
      if (filtrosProcessados.metodos && Array.isArray(filtrosProcessados.metodos) && filtrosProcessados.metodos.length > 0) {
        // Se há apenas um método selecionado, usamos o campo metodo original para compatibilidade
        if (filtrosProcessados.metodos.length === 1) {
          filtrosProcessados.metodo = filtrosProcessados.metodos[0];
        } else {
          // Se há múltiplos métodos, enviamos como um array JSON stringificado
          filtrosProcessados.metodo = JSON.stringify(filtrosProcessados.metodos);
        }
      } else {
        // Se não há métodos selecionados, enviamos null
        filtrosProcessados.metodo = null;
      }
      
      // Processar filtros de hosts
      if (filtrosProcessados.hostids && Array.isArray(filtrosProcessados.hostids) && filtrosProcessados.hostids.length > 0) {
        // Se há apenas um host selecionado, usamos o campo hostid original para compatibilidade
        if (filtrosProcessados.hostids.length === 1) {
          filtrosProcessados.hostid = filtrosProcessados.hostids[0].hostId;
        } else {
          // Se há múltiplos hosts, enviamos como um array JSON stringificado (igual aos sistemas)
          const hostIds = filtrosProcessados.hostids.map(host => host.hostId);
          filtrosProcessados.hostid = JSON.stringify(hostIds);
        }
      } else {
        // Se não há hosts selecionados, enviamos null
        filtrosProcessados.hostid = null;
      }
      
      // Processar filtros de base_size
      if (filtrosProcessados.baseSizeMin !== null && filtrosProcessados.baseSizeMin !== undefined && filtrosProcessados.baseSizeMin !== '') {
        filtrosProcessados.baseSizeMin = parseFloat(filtrosProcessados.baseSizeMin);
      } else {
        delete filtrosProcessados.baseSizeMin;
      }
      
      if (filtrosProcessados.baseSizeMax !== null && filtrosProcessados.baseSizeMax !== undefined && filtrosProcessados.baseSizeMax !== '') {
        filtrosProcessados.baseSizeMax = parseFloat(filtrosProcessados.baseSizeMax);
      } else {
        delete filtrosProcessados.baseSizeMax;
      }
      
      // Remover campos que não são usados pelo backend
      delete filtrosProcessados.horaInicio
      delete filtrosProcessados.horaFim
      delete filtrosProcessados.metodos
      delete filtrosProcessados.sistemas
      delete filtrosProcessados.hostids
      
      
      return filtrosProcessados
    },

    async analisarLogIA(item) {
      // Marcar item como analisando
      item.analisandoIA = true
      this.selectedLogForAnalysis = item
      this.iaAnalysisDialog = true
      
      // A análise será feita pelo componente DashboardIaAnalyzer
      setTimeout(() => {
        item.analisandoIA = false
      }, 500)
    },
    
    abrirAnalisadorIA(dadosAtualizacao) {
      // Este método é chamado quando o usuário clica no ícone de IA dentro do visualizador de logs
      this.selectedLogForAnalysis = {
        id: dadosAtualizacao.id,
        hostid: dadosAtualizacao.hostId,
        hostName: dadosAtualizacao.hostName,
        sistema: dadosAtualizacao.sistema,
        dataFormatada: dadosAtualizacao.dataFormatada
      }
      this.iaAnalysisDialog = true
    },
    
    /**
     * Abre o modal para visualizar comentário (somente leitura)
     */
    async verComentario(item) {
      
      this.selectedComentarioItem = { ...item, modo: 'visualizar' };
      this.selectedRetryItem = null; // Limpar retry anterior
      
      // Buscar dados do retry se disponível
      if (item.metodo === 'CRONOGRAMA') {
        try {
          
          // Extrair a data específica do item (não usar os filtros globais)
          let dataItem = null;
          if (item.started_at) {
            // Extrair apenas a parte da data (YYYY-MM-DD) do started_at
            const dataPartes = item.started_at.split('T')[0];
            dataItem = dataPartes;
          }
          
          // Se não conseguir extrair a data do item, usar os filtros globais como fallback
          const dataInicio = dataItem ? `${dataItem}T00:00:00` : (this.filtros.dataInicio || this.obterDataAtual());
          const dataFim = dataItem ? `${dataItem}T23:59:59` : (this.filtros.dataFim || this.obterDataAtual());
          
          // Garantir que as datas tenham formato completo
          const dataInicioCompleta = dataInicio.includes('T') ? dataInicio : `${dataInicio}T00:00:00`;
          const dataFimCompleta = dataFim.includes('T') ? dataFim : `${dataFim}T23:59:59`;
          
          
          const filtrosRetry = {
            dataInicio: dataInicioCompleta,
            dataFim: dataFimCompleta,
            hostid: item.hostid,
            sistema: item.sistema,
            // Buscar especificamente por CRONOGRAMA_RETRY
            metodo: 'CRONOGRAMA_RETRY',
            // Não aplicar regra de retry para buscar todos os retries
            aplicarRegraRetry: false
          };
          
          
          // Buscar com limite maior para garantir que encontremos o retry
          const response = await dashboardService.getAtualizacoes(filtrosRetry, 1, 100);
          
          
          if (response.success && response.atualizacoes && response.atualizacoes.length > 0) {
            // Buscar o retry que corresponde ao mesmo dia do CRONOGRAMA
            let retryEncontrado = null;
            
            if (dataItem) {
              // Se temos a data específica, procurar retry do mesmo dia
              retryEncontrado = response.atualizacoes.find(a => 
                a.metodo === 'CRONOGRAMA_RETRY' && 
                a.started_at && 
                a.started_at.split('T')[0] === dataItem
              );
              
              if (!retryEncontrado) {
                retryEncontrado = response.atualizacoes[0];
              }
            } else {
              // Fallback: pegar o primeiro
              retryEncontrado = response.atualizacoes[0];
            }
            
            if (retryEncontrado && retryEncontrado.metodo === 'CRONOGRAMA_RETRY') {
              this.selectedRetryItem = retryEncontrado;
            } else {
            }
          }
        } catch (error) {
          console.warn('Erro ao buscar retry para comentário:', error);
          console.error('Detalhes do erro:', error);
        }
      }
      
      // Aguardar um tick para garantir que os dados foram atualizados
      await this.$nextTick();
      
      this.comentarioDialog = true;
    },
    
    /**
     * Abre o modal para editar comentário
     */
    editarComentario(item) {
      this.selectedComentarioItem = { ...item, modo: 'editar' };
      
      // Se o item tem dados de retry relacionado, usar esses dados
      if (item.atualizacaoRetry) {
        this.selectedRetryItem = item.atualizacaoRetry;
      } else {
        this.selectedRetryItem = null;
      }
      
      this.comentarioDialog = true;
    },
    
    /**
     * Verifica se um item tem comentário
     */
    temComentario(item) {
      if (!item || !item.comentario) {
        return false;
      }
      
      // Se comentario é uma string JSON, fazer parse
      if (typeof item.comentario === 'string') {
        try {
          const comentarioParseado = JSON.parse(item.comentario);
          return comentarioParseado && comentarioParseado.comentario && comentarioParseado.comentario.trim() !== '';
        } catch (error) {
          return false;
        }
      }
      
      // Se comentario é um objeto, verificar se tem conteúdo
      if (typeof item.comentario === 'object') {
        return item.comentario.comentario && item.comentario.comentario.trim() !== '';
      }
      
      return false;
    },

    /**
     * Callback quando um comentário é salvo
     */
    onComentarioSalvo(dadosComentario) {
      
      // Atualizar o item na lista de falhas para refletir a mudança de cor
      if (dadosComentario && dadosComentario.id) {
        const itemIndex = this.falhas.findIndex(item => item.id === dadosComentario.id);
        if (itemIndex !== -1) {
          // Atualizar o comentário no item
          this.falhas[itemIndex].comentario = dadosComentario;
          // Forçar reatividade do Vue
          this.$set(this.falhas, itemIndex, { ...this.falhas[itemIndex] });
        }
      }
    },
    
    /**
     * Carrega todos os RETRYs bem-sucedidos da API e armazena em cache
     */
    async carregarRetryBemSucedidos() {
      // Evitar múltiplas chamadas simultâneas
      if (this.loadingRetryData) {
        return;
      }
      
      this.loadingRetryData = true;
      
      try {
        console.group('🔄 Carregando dados de RETRY bem-sucedidos');
        
        const dataInicio = this.filtros.dataInicio || this.obterDataAtual();
        const dataFim = this.filtros.dataFim || this.obterDataAtual();
        
        // ===== CORREÇÃO: Usar os mesmos filtros do usuário =====
        // Criar filtros baseados na seleção atual do usuário
        const filtrosRetry = {
          dataInicio: `${dataInicio}T00:00:00`,
          dataFim: `${dataFim}T23:59:59`
        };
        
        // Se o usuário selecionou um filtro de status, aplicá-lo também
        if (this.filtros.atualizado !== null) {
          filtrosRetry.atualizado = this.filtros.atualizado;
        }
        
        // Buscar RETRYs bem-sucedidos respeitando os filtros do usuário
        const response = await dashboardService.getAtualizacoes(
          filtrosRetry,
          1, 
          1000
        ); // Buscar até 1000 registros para garantir que temos todos
        
        if (response.success && response.atualizacoes) {
          
          // Limpar cache anterior
          this.retryBemSucedidoCache.clear();
          
          // Preencher cache com novos dados
          response.atualizacoes.forEach(item => {
            if (item.metodo === 'CRONOGRAMA_RETRY' && item.atualizado === true) {
              // Criar uma chave composta de hostid + sistema + data (sem hora)
              const dataFormatada = this.extrairDataSemHora(item.started_at);
              const chave = `${item.hostid}_${item.sistema}_${dataFormatada}`;
              this.retryBemSucedidoCache.add(chave);
            }
          });
          
          
          // Marcar como carregado
          this.retryDataLoaded = true;
          
          // REMOVIDO: Carregar RETRYs afeta apenas dados da TABELA, não os gráficos
          // Os gráficos usam dados de ESTATÍSTICAS globais, não dados de retry da tabela
          // if (this.graficosInicializados) {
          //   this.atualizarGraficosSeNecessario();
          // }
          
          // Forçar atualização da interface
          this.$forceUpdate();
        }
      } catch (error) {
        console.error('Erro ao carregar RETRYs bem-sucedidos:', error);
      } finally {
        this.loadingRetryData = false;
        console.groupEnd();
      }
    },
    
    /**
     * NOVO MÉTODO: Atualiza os gráficos apenas quando necessário, sem recriar
     */
    atualizarGraficosSeNecessario() {
      // Se os gráficos não estão inicializados, não fazer nada
      if (!this.graficosInicializados) {
        return;
      }
      
      // Se ainda não temos dados principais, não atualizar
      if (!this.dadosPrincipaisCarregados) {
        return;
      }
      
      // Se estamos carregando configurações de cronograma, aguardar
      // Removido: não precisamos mais verificar se configurações foram carregadas
      // pois agora carregamos apenas quando o usuário clica no host
      
      // Verificação adicional de segurança para dados válidos
      if (!this.estatisticas || typeof this.estatisticas !== 'object') {
        console.warn('🚨 Estatísticas não disponíveis para atualizar gráficos');
        return;
      }
      
      
      try {
        // Verificar se cada método de atualização existe antes de chamar
        if (typeof this.atualizarGraficoSistemas === 'function') {
        this.atualizarGraficoSistemas();
        }
        if (typeof this.atualizarGraficoSistemasPorHost === 'function') {
        this.atualizarGraficoSistemasPorHost();
        }
        if (typeof this.atualizarGraficoMetodos === 'function') {
        this.atualizarGraficoMetodos();
        }
        if (typeof this.atualizarGraficoMetodosPorHost === 'function') {
        this.atualizarGraficoMetodosPorHost();
        }
        if (typeof this.atualizarGraficoAtualizacoesPorcentagem === 'function') {
        this.atualizarGraficoAtualizacoesPorcentagem();
        }
        if (typeof this.atualizarGraficoClientesPorcentagem === 'function') {
        this.atualizarGraficoClientesPorcentagem();
        }
      } catch (error) {
        console.error('Erro ao atualizar gráficos:', error);
        console.error('Stack trace:', error.stack);
        
        // Em caso de erro, tentar recriar os gráficos
        this.graficosInicializados = false;
        this.criarGraficos();
      }
    },
    
    /**
     * NOVO MÉTODO: Atualiza o gráfico de sistemas usando chart.update()
     */
    atualizarGraficoSistemas() {
      if (!this.chartSistemas) {
        console.warn('🚨 chartSistemas não está disponível');
        return;
      }
      
      const dados = this.estatisticasPorSistemaAjustadas;
      
      
      if (!dados || !Array.isArray(dados) || dados.length === 0) {
        console.warn('🚨 Dados de sistemas vazios, não atualizando gráfico');
        return;
      }
      
      try {
        // Verificar se todos os itens têm as propriedades necessárias
        const dadosValidos = dados.filter(item => 
          item && 
          typeof item === 'object' && 
          item.sistema !== undefined && 
          item.sucessos !== undefined && 
          item.falhas !== undefined
        );
        
        if (dadosValidos.length === 0) {
          console.warn('🚨 Nenhum dado válido encontrado para gráfico de sistemas');
          return;
        }
        
        // Ordenar dados seguindo a sequência padrão
        const dadosOrdenados = this.ordenarDadosPorSistema(dadosValidos, 'sistema');
        
        // Verificar se o gráfico ainda existe antes de atualizar
        if (!this.chartSistemas || !this.chartSistemas.data) {
          console.warn('🚨 Gráfico de sistemas foi destruído, recriando...');
          this.criarGraficoSistemas();
          return;
        }
        
        // Atualizar dados do gráfico com verificações robustas
        if (this.chartSistemas.data && this.chartSistemas.data.datasets && 
            this.chartSistemas.data.datasets[0] && this.chartSistemas.data.datasets[1]) {
          this.chartSistemas.data.labels = dadosOrdenados.map(item => (item && item.sistema) ? item.sistema : 'N/A');
          this.chartSistemas.data.datasets[0].data = dadosOrdenados.map(item => (item && typeof item.sucessos === 'number') ? item.sucessos : 0);
          this.chartSistemas.data.datasets[1].data = dadosOrdenados.map(item => (item && typeof item.falhas === 'number') ? item.falhas : 0);
        } else {
          console.error('🚨 Estrutura do gráfico inválida - recriando...');
          this.chartSistemas.destroy();
          this.criarGraficoSistemas();
          return;
        }
        
        // Atualizar o gráfico
        this.chartSistemas.update('none'); // 'none' para animação mais suave
      } catch (error) {
        console.error('Erro ao atualizar gráfico de sistemas:', error);
        console.error('Stack trace:', error.stack);
        
        // Em caso de erro, recriar o gráfico
        try {
          if (this.chartSistemas) {
            this.chartSistemas.destroy();
          }
          this.criarGraficoSistemas();
        } catch (recreateError) {
          console.error('Erro ao recriar gráfico de sistemas:', recreateError);
        }
      }
    },
    
    /**
     * NOVO MÉTODO: Atualiza o gráfico de sistemas por host usando chart.update()
     */
    atualizarGraficoSistemasPorHost() {
      if (!this.chartSistemasPorHost) {
        return;
      }
      
      const dados = this.estatisticas.estatisticasPorSistemaPorHost || [];
      
      
      if (!dados || !Array.isArray(dados) || dados.length === 0) {
        console.warn('🚨 Dados de sistemas por host vazios ou inválidos');
        return;
      }
      
      try {
        // Ordenar dados seguindo a sequência padrão
        const dadosOrdenados = this.ordenarDadosPorSistema(dados, 'sistema');
        
        // Atualizar dados do gráfico com verificações robustas
        if (this.chartSistemasPorHost.data && this.chartSistemasPorHost.data.datasets && 
            this.chartSistemasPorHost.data.datasets[0] && this.chartSistemasPorHost.data.datasets[1]) {
          this.chartSistemasPorHost.data.labels = dadosOrdenados.map(item => 
            (item && item.sistema) ? item.sistema : 'N/A');
          this.chartSistemasPorHost.data.datasets[0].data = dadosOrdenados.map(item => 
            parseInt(item?.hosts_sucesso) || 0
          );
          this.chartSistemasPorHost.data.datasets[1].data = dadosOrdenados.map(item => 
            parseInt(item?.hosts_falha) || 0
          );
        } else {
          console.error('🚨 Estrutura do gráfico sistemas por host inválida - recriando...');
          this.chartSistemasPorHost.destroy();
          this.criarGraficoSistemasPorHost();
          return;
        }
        
        // Atualizar o gráfico
        this.chartSistemasPorHost.update('none');
      } catch (error) {
        console.error('Erro ao atualizar gráfico de sistemas por host:', error);
      }
    },
    
    /**
     * NOVO MÉTODO: Atualiza o gráfico de métodos usando chart.update()
     */
    atualizarGraficoMetodos() {
      if (!this.chartMetodos) {
        return;
      }
      
      let dados = this.estatisticasPorMetodoAjustadas;
      
      if (!dados || !Array.isArray(dados) || dados.length === 0) {
        return;
      }
      
      // Ordenar dados em ordem decrescente (do maior para o menor valor)
      dados = [...dados].sort((a, b) => (b.total || 0) - (a.total || 0));
      
      try {
        // Cores específicas para cada método (correspondem às cores dos chips no histórico)
        const coresPorMetodo = {
          'CRONOGRAMA': this.getCorMetodoHex('CRONOGRAMA'),
          'CRONOGRAMA_RETRY': this.getCorMetodoHex('CRONOGRAMA_RETRY'),
          'MANUAL': this.getCorMetodoHex('MANUAL'),
          'MANUAL_CRONOGRAMA': this.getCorMetodoHex('MANUAL_CRONOGRAMA')
        };
        
        // Atualizar dados do gráfico com verificações robustas
        if (this.chartMetodos.data && this.chartMetodos.data.datasets && this.chartMetodos.data.datasets[0]) {
          this.chartMetodos.data.labels = dados.map(item => (item && item.metodo) ? item.metodo : 'N/A');
          this.chartMetodos.data.datasets[0].data = dados.map(item => (item && typeof item.total === 'number') ? item.total : 0);
          // Atualizar cores baseadas no método
          this.chartMetodos.data.datasets[0].backgroundColor = dados.map(item => 
            coresPorMetodo[item.metodo] || (this.$vuetify.theme.dark ? '#757575' : '#9E9E9E')
          );
        } else {
          console.error('🚨 Estrutura do gráfico métodos inválida - recriando...');
          this.chartMetodos.destroy();
          this.criarGraficoMetodos();
          return;
        }
        
        // Atualizar o gráfico
        this.chartMetodos.update('none');
      } catch (error) {
        console.error('Erro ao atualizar gráfico de métodos:', error);
      }
    },
    
    /**
     * NOVO MÉTODO: Atualiza o gráfico de métodos por host usando chart.update()
     */
    atualizarGraficoMetodosPorHost() {
      if (!this.chartMetodosPorHost) {
        return;
      }
      
      let dados = this.estatisticas.estatisticasPorMetodoPorHost || [];
      
      if (!dados || !Array.isArray(dados) || dados.length === 0) {
        return;
      }
      
      // Ordenar dados em ordem decrescente (do maior para o menor valor)
      dados = [...dados].sort((a, b) => (b.total_hosts || 0) - (a.total_hosts || 0));
      
      try {
        // Cores específicas para cada método (correspondem às cores dos chips no histórico)
        const coresPorMetodo = {
          'CRONOGRAMA': this.getCorMetodoHex('CRONOGRAMA'),
          'CRONOGRAMA_RETRY': this.getCorMetodoHex('CRONOGRAMA_RETRY'),
          'MANUAL': this.getCorMetodoHex('MANUAL'),
          'MANUAL_CRONOGRAMA': this.getCorMetodoHex('MANUAL_CRONOGRAMA')
        };
        
        // Atualizar dados do gráfico com verificações robustas
        if (this.chartMetodosPorHost.data && this.chartMetodosPorHost.data.datasets && this.chartMetodosPorHost.data.datasets[0]) {
          this.chartMetodosPorHost.data.labels = dados.map(item => (item && item.metodo) ? item.metodo : 'N/A');
          this.chartMetodosPorHost.data.datasets[0].data = dados.map(item => (item && typeof item.total_hosts === 'number') ? item.total_hosts : 0);
          // Atualizar cores baseadas no método
          this.chartMetodosPorHost.data.datasets[0].backgroundColor = dados.map(item => 
            coresPorMetodo[item.metodo] || (this.$vuetify.theme.dark ? '#757575' : '#9E9E9E')
          );
        } else {
          console.error('🚨 Estrutura do gráfico métodos por host inválida - recriando...');
          this.chartMetodosPorHost.destroy();
          this.criarGraficoMetodosPorHost();
          return;
        }
        
        // Atualizar o gráfico
        this.chartMetodosPorHost.update('none');
      } catch (error) {
        console.error('Erro ao atualizar gráfico de métodos por host:', error);
      }
    },
    
    /**
     * NOVO MÉTODO: Atualiza o gráfico de porcentagem de atualizações usando chart.update()
     */
    atualizarGraficoAtualizacoesPorcentagem() {
      if (!this.chartAtualizacoesPorcentagem) {
        return;
      }
      
      const estatisticas = this.estatisticasAjustadas;
      const totalSucessos = estatisticas.totalSucessos || 0;
      const totalFalhas = estatisticas.totalFalhas || 0;
      
      try {
        // Atualizar dados do gráfico com verificações robustas
        if (this.chartAtualizacoesPorcentagem.data && this.chartAtualizacoesPorcentagem.data.datasets && 
            this.chartAtualizacoesPorcentagem.data.datasets[0]) {
        this.chartAtualizacoesPorcentagem.data.datasets[0].data = [totalSucessos, totalFalhas];
        } else {
          console.error('🚨 Estrutura do gráfico atualizações porcentagem inválida - recriando...');
          this.chartAtualizacoesPorcentagem.destroy();
          this.criarGraficoAtualizacoesPorcentagem();
          return;
        }
        
        // Atualizar o gráfico
        this.chartAtualizacoesPorcentagem.update('none');
      } catch (error) {
        console.error('Erro ao atualizar gráfico de porcentagem de atualizações:', error);
      }
    },
    
    /**
     * NOVO MÉTODO: Atualiza o gráfico de porcentagem de clientes usando chart.update()
     */
    atualizarGraficoClientesPorcentagem() {
      if (!this.chartClientesPorcentagem) {
        return;
      }
      
      const totalHosts = this.estatisticas.totalHostsUnicos || 0;
      const hostsSucesso = this.estatisticas.hostsComSucesso || 0;
      const hostsFalha = this.estatisticas.hostsComFalha || 0;
      
      try {
        // Atualizar dados do gráfico com verificações robustas
        if (this.chartClientesPorcentagem.data && this.chartClientesPorcentagem.data.datasets && 
            this.chartClientesPorcentagem.data.datasets[0]) {
        this.chartClientesPorcentagem.data.datasets[0].data = [hostsSucesso, hostsFalha];
        } else {
          console.error('🚨 Estrutura do gráfico clientes porcentagem inválida - recriando...');
          this.chartClientesPorcentagem.destroy();
          this.criarGraficoClientesPorcentagem();
          return;
        }
        
        // Atualizar o gráfico
        this.chartClientesPorcentagem.update('none');
      } catch (error) {
        console.error('Erro ao atualizar gráfico de porcentagem de clientes:', error);
      }
    },
    
    /**
     * Método centralizado para recriar gráficos com debounce - AGORA APENAS PARA CASOS ESPECÍFICOS
     */
    recriarGraficosComDebounce() {
      // Se já está recriando, aguardar
      if (this.graficosRecriando) {
        return;
      }
      
      // Limpar timeout anterior
      if (this.graficosRecriarTimeout) {
        clearTimeout(this.graficosRecriarTimeout);
      }
      
      // Marcar como recriando
      this.graficosRecriando = true;
      
      // Agendar recriação com debounce
      this.graficosRecriarTimeout = setTimeout(() => {
        try {
          this.criarGraficos();
        } catch (error) {
          console.error('Erro ao recriar gráficos:', error);
        } finally {
          // Resetar flag após um delay para evitar recriações imediatas
          setTimeout(() => {
            this.graficosRecriando = false;
          }, 100);
        }
      }, this.graficosRecriarDebounce);
    },
    
    /**
     * NOVO MÉTODO: Ordena dados dos gráficos seguindo ordem padrão VPRA | VSUC | VSUP
     * @param {Array} dados - Array de dados a ser ordenado
     * @param {string} campoSistema - Nome do campo que contém o sistema (ex: 'sistema')
     * @returns {Array} - Array ordenado seguindo a sequência padrão
     */
    ordenarDadosPorSistema(dados, campoSistema = 'sistema') {
      if (!dados || !Array.isArray(dados) || dados.length === 0) {
        console.warn('🚨 ordenarDadosPorSistema - dados inválidos:', dados);
        return [];
      }
      
      // Ordem padrão desejada
      const ordemPadrao = ['VCON', 'VPRA', 'VSUC', 'VSUP', 'VSYN'];
      
      try {
      // Criar um mapa para facilitar a busca
      const dadosMap = new Map();
        dados.forEach((item, index) => {
          if (!item || typeof item !== 'object') {
            console.warn(`🚨 Item inválido no índice ${index}:`, item);
            return;
          }
          
          // Verificar se o item tem propriedades essenciais (diferentes para dados de host vs registro)
          const temPropriedadesRegistro = item.sucessos !== undefined && item.falhas !== undefined;
          const temPropriedadesHost = item.hosts_sucesso !== undefined && item.hosts_falha !== undefined;
          
          if (!temPropriedadesRegistro && !temPropriedadesHost) {
            console.warn(`🚨 Item no índice ${index} sem propriedades essenciais (nem registro nem host):`, {
              item,
              temSucessos: item.sucessos !== undefined,
              temFalhas: item.falhas !== undefined,
              temHostsSucesso: item.hosts_sucesso !== undefined,
              temHostsFalha: item.hosts_falha !== undefined
            });
            return;
          }
          
          const sistema = item[campoSistema];
          if (sistema !== undefined && sistema !== null) {
            dadosMap.set(sistema, item);
          } else {
            console.warn(`🚨 Campo ${campoSistema} não encontrado no item:`, item);
          }
        });
        
        if (dadosMap.size === 0) {
          console.warn('🚨 Nenhum sistema válido encontrado nos dados');
          return [];
        }
      
      // Filtrar apenas os sistemas que existem nos dados
      const sistemasExistentes = ordemPadrao.filter(sistema => 
        dadosMap.has(sistema)
      );
      
      // Ordenar seguindo a sequência padrão, incluindo apenas os que existem
      const dadosOrdenados = sistemasExistentes.map(sistema => 
        dadosMap.get(sistema)
        ).filter(item => item !== undefined); // Filtrar itens undefined
      
        
        return dadosOrdenados;
      } catch (error) {
        console.error('Erro ao ordenar dados por sistema:', error);
        console.error('Stack trace:', error.stack);
        return dados; // Retornar dados originais em caso de erro
      }
    },
    
    /**
     * Verifica se um dia tem atualizações (usado pelo v-date-picker)
     * @param {string} isoDate - Data no formato YYYY-MM-DD
     * @returns {boolean} - true se o dia tem atualizações
     */
    isUpdateDay(isoDate) {
      return this.diasComAtualizacao.has(isoDate);
    },
    
    /**
     * Define a cor do indicador de eventos no calendário
     * @returns {string} - Nome da cor (pode ser uma cor do Vuetify ou código hex)
     */
    eventColor() {
      return 'primary'; // Usando a cor primária do tema
    },
    
    /**
     * Exporta dados do dashboard para Excel ou CSV
     * @param {string} formato - 'xlsx' ou 'csv'
     */
    async exportarDados(formato = 'xlsx') {
      this.exportando = true;
      
      try {
        this.mostrarNotificacao('Preparando dados para exportação...', 'info');
        
        // Processar filtros atuais
        const filtrosProcessados = this.processarFiltros();
        
        // Processar ordenação atual
        let sortBy = null;
        let sortDesc = false;
        if (this.optionsTabela.sortBy && this.optionsTabela.sortBy.length > 0) {
          sortBy = this.optionsTabela.sortBy[0];
          sortDesc = this.optionsTabela.sortDesc && this.optionsTabela.sortDesc.length > 0 
            ? this.optionsTabela.sortDesc[0] 
            : false;
        }
        
        // Buscar todos os dados (sem paginação)
        const [responseAtualizacoes, responseFalhas, responseEstatisticas] = await Promise.all([
          dashboardService.getAllAtualizacoes(
            filtrosProcessados,
            this.searchHistorico,
            this.ignorarFalhasComRetry,
            sortBy,
            sortDesc
          ),
          dashboardService.getAllFalhas(
            filtrosProcessados,
            this.ignorarFalhasComRetry,
            this.searchFalhas
          ),
          dashboardService.getEstatisticas(filtrosProcessados, this.ignorarFalhasComRetry)
        ]);
        
        // Processar dados de atualizações
        const atualizacoes = responseAtualizacoes.success && responseAtualizacoes.atualizacoes
          ? responseAtualizacoes.atualizacoes.map(item => this.formatarItemParaExportacao(item))
          : [];
        
        // Processar dados de falhas
        const falhas = responseFalhas.success && responseFalhas.falhas
          ? responseFalhas.falhas.map(item => this.formatarItemParaExportacao(item))
          : [];
        
        // Preparar dados de estatísticas
        const estatisticas = responseEstatisticas.success && responseEstatisticas.estatisticas
          ? this.formatarEstatisticasParaExportacao(responseEstatisticas.estatisticas)
          : [];
        
        // Criar workbook
        const workbook = XLSX.utils.book_new();
        
        // Aba 1: Atualizações
        if (atualizacoes.length > 0) {
          const wsAtualizacoes = XLSX.utils.json_to_sheet(atualizacoes);
          XLSX.utils.book_append_sheet(workbook, wsAtualizacoes, 'Atualizações');
        }
        
        // Aba 2: Falhas
        if (falhas.length > 0) {
          const wsFalhas = XLSX.utils.json_to_sheet(falhas);
          XLSX.utils.book_append_sheet(workbook, wsFalhas, 'Falhas');
        }
        
        // Aba 3: Estatísticas Gerais
        if (estatisticas.gerais && estatisticas.gerais.length > 0) {
          const wsEstatisticasGerais = XLSX.utils.json_to_sheet(estatisticas.gerais);
          XLSX.utils.book_append_sheet(workbook, wsEstatisticasGerais, 'Estatísticas Gerais');
        }
        
        // Aba 4: Estatísticas por Sistema
        if (estatisticas.porSistema && estatisticas.porSistema.length > 0) {
          const wsPorSistema = XLSX.utils.json_to_sheet(estatisticas.porSistema);
          XLSX.utils.book_append_sheet(workbook, wsPorSistema, 'Por Sistema');
        }
        
        // Aba 5: Estatísticas por Método
        if (estatisticas.porMetodo && estatisticas.porMetodo.length > 0) {
          const wsPorMetodo = XLSX.utils.json_to_sheet(estatisticas.porMetodo);
          XLSX.utils.book_append_sheet(workbook, wsPorMetodo, 'Por Método');
        }
        
        // Gerar nome do arquivo com data/hora
        const dataHora = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
        const nomeArquivo = `dashboard-export-${dataHora}.${formato === 'csv' ? 'csv' : 'xlsx'}`;
        
        // Exportar arquivo
        if (formato === 'csv') {
          // Para CSV, exportar apenas a primeira aba (Atualizações)
          if (atualizacoes.length > 0) {
            const ws = XLSX.utils.json_to_sheet(atualizacoes);
            XLSX.writeFile(ws, nomeArquivo, { bookType: 'csv' });
          } else if (falhas.length > 0) {
            // Se não há atualizações, exportar falhas
            const ws = XLSX.utils.json_to_sheet(falhas);
            XLSX.writeFile(ws, nomeArquivo, { bookType: 'csv' });
          } else {
            throw new Error('Nenhum dado disponível para exportação');
          }
        } else {
          // Para XLSX, exportar todas as abas
          XLSX.writeFile(workbook, nomeArquivo, { bookType: 'xlsx' });
        }
        
        this.mostrarNotificacao(
          `Dados exportados com sucesso! Total: ${atualizacoes.length} atualizações, ${falhas.length} falhas`,
          'success'
        );
      } catch (error) {
        console.error('Erro ao exportar dados:', error);
        this.mostrarNotificacao(
          `Erro ao exportar dados: ${error.message || 'Erro desconhecido'}`,
          'error'
        );
      } finally {
        this.exportando = false;
      }
    },
    
    /**
     * Formata um item para exportação (remove campos desnecessários e formata valores)
     * @param {Object} item - Item a ser formatado
     * @returns {Object} - Item formatado
     */
    formatarItemParaExportacao(item) {
      return {
        'ID': item.id || '',
        'Host': item.host_name || item.hostName || '',
        'HostID': item.hostid || '',
        'Sistema': item.sistema || '',
        'Base (GB)': item.base_size || '',
        'Método': item.metodo || '',
        'Versão Atual': item.versao_atual || '',
        'Versão Final': item.versao_final || '',
        'Status': item.atualizado ? 'Sucesso' : 'Falha',
        'Iniciado em': item.started_at ? this.formatarData(item.started_at) : '',
        'Duração': item.duracao ? this.formatarDuracao(item.duracao) : '',
        'Comentário': this.extrairComentario(item.comentario) || ''
      };
    },
    
    /**
     * Extrai comentário de um item (pode ser string JSON ou objeto)
     * @param {string|Object} comentario - Comentário a ser extraído
     * @returns {string} - Comentário formatado
     */
    extrairComentario(comentario) {
      if (!comentario) return '';
      
      try {
        if (typeof comentario === 'string') {
          const parsed = JSON.parse(comentario);
          return parsed.comentario || '';
        } else if (typeof comentario === 'object' && comentario.comentario) {
          return comentario.comentario;
        }
        return '';
      } catch (error) {
        return typeof comentario === 'string' ? comentario : '';
      }
    },
    
    /**
     * Formata estatísticas para exportação
     * @param {Object} estatisticas - Estatísticas do backend
     * @returns {Object} - Estatísticas formatadas
     */
    formatarEstatisticasParaExportacao(estatisticas) {
      const resultado = {
        gerais: [],
        porSistema: [],
        porMetodo: []
      };
      
      // Estatísticas gerais
      resultado.gerais = [
        { 'Métrica': 'Total de Atualizações', 'Valor': estatisticas.totalAtualizacoes || 0 },
        { 'Métrica': 'Total de Sucessos', 'Valor': estatisticas.totalSucessos || 0 },
        { 'Métrica': 'Total de Falhas', 'Valor': estatisticas.totalFalhas || 0 },
        { 'Métrica': 'Taxa de Sucesso (%)', 'Valor': estatisticas.totalAtualizacoes > 0 
          ? ((estatisticas.totalSucessos / estatisticas.totalAtualizacoes) * 100).toFixed(2) 
          : 0 },
        { 'Métrica': 'Total de Clientes', 'Valor': estatisticas.totalHostsUnicos || 0 },
        { 'Métrica': 'Clientes com Sucesso', 'Valor': estatisticas.hostsComSucesso || 0 },
        { 'Métrica': 'Clientes com Falha', 'Valor': estatisticas.hostsComFalha || 0 },
        { 'Métrica': 'Taxa de Sucesso por Cliente (%)', 'Valor': estatisticas.taxaSucessoPorHost || 0 },
        { 'Métrica': 'Tempo Médio de Execução', 'Valor': estatisticas.tempoMedioExecucao 
          ? this.formatarDuracao(estatisticas.tempoMedioExecucao) 
          : 'N/A' }
      ];
      
      // Estatísticas por sistema
      if (estatisticas.estatisticasPorSistema && Array.isArray(estatisticas.estatisticasPorSistema)) {
        resultado.porSistema = estatisticas.estatisticasPorSistema.map(item => ({
          'Sistema': item.sistema || '',
          'Sucessos': item.sucessos || 0,
          'Falhas': item.falhas || 0,
          'Total': (item.sucessos || 0) + (item.falhas || 0),
          'Taxa de Sucesso (%)': ((item.sucessos || 0) + (item.falhas || 0)) > 0
            ? (((item.sucessos || 0) / ((item.sucessos || 0) + (item.falhas || 0))) * 100).toFixed(2)
            : 0
        }));
      }
      
      // Estatísticas por método
      if (estatisticas.estatisticasPorMetodo && Array.isArray(estatisticas.estatisticasPorMetodo)) {
        resultado.porMetodo = estatisticas.estatisticasPorMetodo.map(item => ({
          'Método': item.metodo || '',
          'Total': item.total || 0,
          'Porcentagem (%)': estatisticas.totalAtualizacoes > 0
            ? (((item.total || 0) / estatisticas.totalAtualizacoes) * 100).toFixed(2)
            : 0
        }));
      }
      
      return resultado;
    },
    
    /**
     * Carrega dias que contêm atualizações para mostrar no calendário
     * @param {string} yyyyMM - Mês no formato YYYY-MM
     * @returns {Promise<void>}
     */
    async carregarDiasComAtualizacao(yyyyMM) {
      // Verificar se já temos os dados em cache
      if (this.cacheDiasComAtualizacao[yyyyMM]) {
        this.diasComAtualizacao = this.cacheDiasComAtualizacao[yyyyMM];
        this.ultimoMesCarregado = yyyyMM;
        return;
      }
      
      // Evitar múltiplas chamadas simultâneas
      if (this.carregandoDiasComAtualizacao) {
        return;
      }
      
      this.carregandoDiasComAtualizacao = true;
      
      try {
        
        // Calcular início/fim do mês
        const [ano, mes] = yyyyMM.split('-').map(Number);
        const inicio = `${yyyyMM}-01`;
        
        // Último dia do mês (mes é 1-12 para Date, mas 0-11 para construtor)
        const ultimoDia = new Date(ano, mes, 0).getDate();
        const fim = `${yyyyMM}-${String(ultimoDia).padStart(2, '0')}`;
        
        
        try {
          // Chamar a API para obter os dias com atualizações usando a query SQL fornecida
          // A query retorna apenas dias com atualizações (todos com atualizacao = true)
          const response = await dashboardService.getDiasComAtualizacao(inicio, fim);
          
          // Verificar a estrutura da resposta e extrair os dados corretamente
          let diasComAtualizacao = [];
          
          // Se a resposta está no formato { success: true, data: [...] }
          if (response && response.success === true && Array.isArray(response.data)) {
            diasComAtualizacao = response.data;
          } 
          // Se a resposta é diretamente um array
          else if (Array.isArray(response)) {
            diasComAtualizacao = response;
          }
          // Caso a resposta seja um objeto sem a estrutura esperada
          else if (response && typeof response === 'object') {
            // Tentar encontrar algum array na resposta
            for (const key in response) {
              if (Array.isArray(response[key])) {
                diasComAtualizacao = response[key];
                break;
              }
            }
          }
          
          // Verificar se diasComAtualizacao tem a estrutura esperada
          if (diasComAtualizacao && diasComAtualizacao.length > 0) {
            
            // Verificar se cada item tem a propriedade 'data'
            if (diasComAtualizacao[0] && diasComAtualizacao[0].data) {
              // Extrair as datas e criar um Set
              const novoSet = new Set(
                diasComAtualizacao.map(row => row.data)
              );
              
              // Atualizar o Set atual
              this.diasComAtualizacao = novoSet;
              
              // Salvar no cache
              this.cacheDiasComAtualizacao[yyyyMM] = novoSet;
            } else {
              console.error('Estrutura de dados inesperada. Não foi encontrada a propriedade "data":', diasComAtualizacao[0]);
              this.diasComAtualizacao = new Set();
            }
          } else {
            this.diasComAtualizacao = new Set();
            // Salvar set vazio no cache para evitar requisições futuras
            this.cacheDiasComAtualizacao[yyyyMM] = new Set();
          }
          
          
          // Registrar que carregamos dados para este mês
          this.ultimoMesCarregado = yyyyMM;
        } catch (apiError) {
          console.error('Erro ao buscar dias com atualizações da API:', apiError);
          // Em caso de erro na API, limpar os dados para evitar inconsistências
          this.diasComAtualizacao = new Set();
        }
      } catch (error) {
        console.error('Erro ao carregar dias com atualizações:', error);
        // Em caso de erro geral, limpar os dados para evitar inconsistências
        this.diasComAtualizacao = new Set();
      } finally {
        this.carregandoDiasComAtualizacao = false;
      }
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  padding: 20px;
}

/* Melhorias para visibilidade em tema escuro */
.theme-dark .chip-hostid,
.theme-dark .chip-id {
  border-width: 2px !important;
  font-weight: 700 !important;
}

.theme-dark .v-chip.outlined.chip-hostid {
  color: #90caf9 !important;
  border-color: #90caf9 !important;
}

.theme-dark .v-chip.outlined.chip-id {
  color: #80cbc4 !important;
  border-color: #80cbc4 !important;
}

.theme-dark .v-data-table tbody tr:hover td .v-chip.outlined {
  background-color: rgba(0, 0, 0, 0.2) !important;
}

/* Estilo específico para CRONOGRAMA_RETRY - cor fixa #03dac6 independente do tema */
.v-chip[style*="#03dac6"] {
  border-color: #03dac6 !important;
  color: #03dac6 !important;
}

.theme-dark .v-chip[style*="#03dac6"],
.theme--light .v-chip[style*="#03dac6"] {
  border-color: #03dac6 !important;
  color: #03dac6 !important;
}

.v-card {
  height: 100%;
}

.text-h3 {
  line-height: 1.2;
}

.sistema-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e0e0e0;
}

#chartAtualizacoesPorcentagem {
  max-width: 100px;
  max-height: 100px;
  margin: 0 auto;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.metrics-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -4px; /* Reduzir ainda mais as margens entre colunas */
}

.metric-col {
  flex: 1;
  min-width: 0;
  position: relative;
  padding: 0 4px; /* Reduzir padding interno */
  margin-bottom: 12px; /* Reduzir espaçamento entre linhas */
}

/* Garantir que os cartões ocupem toda a largura disponível */
.metric-col .v-card {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: visible;
  min-height: 140px; /* Reduzir altura mínima */
  display: flex;
  flex-direction: column;
}

.metric-col .v-card .v-card__text {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px 12px; /* Reduzir padding interno */
}

.metric-col .v-card {
  position: relative;
  overflow: visible;
  min-height: 140px;
}

.chart-container {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.porcentagem-info {
  margin-top: 10px;
}

.color-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.success-color {
  background-color: #4CAF50;
}

.error-color {
  background-color: #F44336;
}

@media (max-width: 959px) {
  .metric-col {
    flex: 0 0 50%;
    max-width: 50%;
  }
  
  .metric-col .v-card {
    min-height: 120px;
  }
}

@media (max-width: 599px) {
  .metric-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
  
  .metric-col .v-card {
    min-height: 100px;
  }
}

/* Otimizações para telas grandes */
@media (min-width: 1200px) {
  .metric-col .v-card {
    min-height: 150px;
  }
  
  .metric-col .v-card .v-card__text {
    padding: 18px 14px;
  }
}

/* Responsividade para gráficos */
@media (max-width: 768px) {
  .dashboard-container {
    padding: 10px;
  }
}

/* Centralização do switch de vídeo */
.v-data-table .video-toggle-cell {
  text-align: center !important;
  vertical-align: middle !important;
}

.v-data-table .video-toggle-cell .v-switch {
  margin: 0 auto !important;
}

/* Estilos para o card de detalhes do retry */
.retry-details {
  background-color: #f8f9fa !important;
  border-left: 4px solid #2196F3;
}

/* Animação para expansão suave */
.v-data-table__expanded__content {
  transition: all 0.3s ease-out;
}

/* Estilos modernos para cards de métricas */
.modern-metric-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.8) 100%);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 16px !important;
}

.modern-metric-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
}

.modern-metric-card-alt {
  background: linear-gradient(135deg, rgba(227, 242, 253, 0.9) 0%, rgba(187, 222, 251, 0.8) 100%);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(33, 150, 243, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 16px !important;
}

.modern-metric-card-alt:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(33, 150, 243, 0.2) !important;
}

/* Cards de gráficos modernos */
.modern-chart-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.9) 100%);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 20px !important;
  overflow: hidden;
}

.modern-chart-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
}

.modern-chart-card-alt {
  background: linear-gradient(135deg, rgba(227, 242, 253, 0.95) 0%, rgba(187, 222, 251, 0.9) 100%);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(33, 150, 243, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 20px !important;
  overflow: hidden;
}

.modern-chart-card-alt:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 60px rgba(33, 150, 243, 0.2) !important;
}

/* Títulos dos gráficos modernos */
.modern-chart-title {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 0.9rem !important;
  font-weight: 600 !important;
  color: #495057 !important;
  padding: 16px 20px !important;
}

.modern-chart-title-alt {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-bottom: 1px solid rgba(33, 150, 243, 0.2);
  font-size: 0.9rem !important;
  font-weight: 600 !important;
  color: #1976d2 !important;
  padding: 16px 20px !important;
}

/* Tema escuro para cards de métricas */
.theme-dark .modern-metric-card {
  background: linear-gradient(135deg, rgba(30, 30, 30, 0.9) 0%, rgba(45, 45, 45, 0.8) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.theme-dark .modern-metric-card-alt {
  background: linear-gradient(135deg, rgba(30, 30, 30, 0.9) 0%, rgba(45, 45, 45, 0.8) 100%);
  border: 1px solid rgba(33, 150, 243, 0.3);
}

/* Tema escuro para cards de gráficos */
.theme-dark .modern-chart-card {
  background: linear-gradient(135deg, rgba(30, 30, 30, 0.95) 0%, rgba(45, 45, 45, 0.9) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.theme-dark .modern-chart-card-alt {
  background: linear-gradient(135deg, rgba(30, 30, 30, 0.95) 0%, rgba(45, 45, 45, 0.9) 100%);
  border: 1px solid rgba(33, 150, 243, 0.3);
}

/* Tema escuro para títulos dos gráficos */
.theme-dark .modern-chart-title {
  background: linear-gradient(135deg, #2d2d2d 0%, #3d3d3d 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff !important;
}

.theme-dark .modern-chart-title-alt {
  background: linear-gradient(135deg, #1e3a5f 0%, #2d4a6b 100%);
  border-bottom: 1px solid rgba(33, 150, 243, 0.3);
  color: #64b5f6 !important;
}

/* Os indicadores de datas com atualizações são gerenciados pelo Vuetify */

/* Estilos para o filtro de base_size */
.base-size-filter {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 10px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.base-size-filter:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.base-size-filter .v-text-field {
  font-size: 12px;
}

.base-size-filter .v-text-field .v-input__control {
  min-height: 32px;
}

.base-size-filter .v-text-field .v-label {
  font-size: 11px;
}

.base-size-filter .v-slider {
  margin: 8px 0;
}

.base-size-filter .v-slider__thumb {
  border: 2px solid #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.base-size-filter .v-slider__track-fill {
  background: linear-gradient(90deg, #2196F3 0%, #21CBF3 100%);
}

/* Tema escuro para filtro de base_size */
.theme-dark .base-size-filter {
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: linear-gradient(135deg, rgba(30, 30, 30, 0.9) 0%, rgba(45, 45, 45, 0.7) 100%);
  backdrop-filter: blur(10px);
}

.theme-dark .base-size-filter:hover {
  box-shadow: 0 4px 16px rgba(255, 255, 255, 0.1);
}

.theme-dark .base-size-filter .v-slider__thumb {
  border: 2px solid #333;
}

.theme-dark .base-size-filter .v-slider__track-fill {
  background: linear-gradient(90deg, #64B5F6 0%, #42A5F5 100%);
}

/* Estilos para os campos laterais do slider */
.slider-value-display {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 90px;
}

.slider-input .v-input__control {
  min-height: 36px !important;
}

.slider-input .v-text-field__details {
  display: none !important;
}

.slider-input input {
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.slider-input .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center;
  padding-left: 4px;
}

.slider-input .v-input__append-inner .text-caption {
  font-size: 10px !important;
  font-weight: 500;
  color: #666 !important;
}

/* Responsividade para telas menores */
@media (max-width: 960px) {
  .slider-value-display {
    min-width: 80px;
  }
  
  .slider-input {
    width: 80px !important;
  }
  
  .slider-input input {
    font-size: 11px;
  }
}

/* Tema escuro para campos laterais */
.theme-dark .slider-input .v-input__append-inner .text-caption {
  color: #aaa !important;
}

/* Animação para feedback em tempo real */
.base-size-filter .text-caption.primary--text {
  transition: all 0.2s ease;
  text-shadow: 0 0 4px rgba(33, 150, 243, 0.3);
}

.base-size-filter .v-slider.v-slider--is-active .v-slider__track-fill {
  box-shadow: 0 0 8px rgba(33, 150, 243, 0.4);
  transition: box-shadow 0.2s ease;
}

/* Animação dos campos durante arraste */
.slider-input.active {
  transform: scale(1.02);
  transition: transform 0.2s ease;
}

.slider-input input:focus {
  background-color: rgba(33, 150, 243, 0.05);
}

/* Animações de entrada */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modern-metric-card,
.modern-metric-card-alt,
.modern-chart-card,
.modern-chart-card-alt {
  animation: fadeInUp 0.6s ease-out;
}

/* Delay escalonado para animações */
.modern-metric-card:nth-child(1) { animation-delay: 0.1s; }
.modern-metric-card:nth-child(2) { animation-delay: 0.2s; }
.modern-metric-card:nth-child(3) { animation-delay: 0.3s; }
.modern-metric-card:nth-child(4) { animation-delay: 0.4s; }
.modern-metric-card:nth-child(5) { animation-delay: 0.5s; }

.modern-chart-card:nth-child(1) { animation-delay: 0.6s; }
.modern-chart-card:nth-child(2) { animation-delay: 0.7s; }
.modern-chart-card:nth-child(3) { animation-delay: 0.8s; }
.modern-chart-card:nth-child(4) { animation-delay: 0.9s; }

/* Melhorias nos gráficos pequenos */
.chart-container {
  position: relative;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-container canvas {
  max-height: 100%;
  max-width: 100%;
}

/* Padronização dos gráficos de métodos */
#chartMetodos,
#chartMetodosPorHost {
  width: 100% !important;
  height: 300px !important;
  max-width: 100% !important;
  max-height: 300px !important;
}

/* Garantir que os cards dos gráficos de métodos tenham a mesma altura e layout */
.modern-chart-card .v-card-text,
.modern-chart-card-alt .v-card-text {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px !important;
}

/* Responsividade melhorada */
@media (max-width: 768px) {
  .modern-metric-card,
  .modern-metric-card-alt,
  .modern-chart-card,
  .modern-chart-card-alt {
    border-radius: 12px !important;
  }
  
  .modern-chart-title,
  .modern-chart-title-alt {
    font-size: 0.8rem !important;
    padding: 12px 16px !important;
  }
}
</style> 